/* tslint:disable */
/* eslint-disable */
//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.9.4.0 (NJsonSchema v10.3.1.0 (Newtonsoft.Json v12.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------
// ReSharper disable InconsistentNaming

import axios, { AxiosError, AxiosInstance, AxiosRequestConfig, AxiosResponse, CancelToken } from 'axios';
import {APP_SCOPE, sdk} from '@/utils/sdk';

export class UomServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Adds new units of measure (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addUnitsOfMeasure(body: string[] | null | undefined , signal?: AbortSignal): Promise<AddUomResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/units-of-measure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUnitsOfMeasure(_response);
        });
    }

    protected processAddUnitsOfMeasure(response: AxiosResponse): Promise<AddUomResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUomResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUomResponseOkResponse>(<any>null);
    }

    /**
     * Deletes units of measure (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    deleteUnitsOfMeasure(body: number[] | null | undefined , signal?: AbortSignal): Promise<DeleteUomResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/units-of-measure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteUnitsOfMeasure(_response);
        });
    }

    protected processDeleteUnitsOfMeasure(response: AxiosResponse): Promise<DeleteUomResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteUomResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteUomResponseOkResponse>(<any>null);
    }

    /**
     * Edits units of measure (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    editUnitsOfMeasure(body: UnitOfMeasureUpdateDto[] | null | undefined , signal?: AbortSignal): Promise<EditUomResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/units-of-measure";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditUnitsOfMeasure(_response);
        });
    }

    protected processEditUnitsOfMeasure(response: AxiosResponse): Promise<EditUomResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditUomResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditUomResponseOkResponse>(<any>null);
    }

    /**
     * List units of measure (Auth policies: AdminPolicy)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    listUnitsOfMeasure(page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<ListUomResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/units-of-measure?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListUnitsOfMeasure(_response);
        });
    }

    protected processListUnitsOfMeasure(response: AxiosResponse): Promise<ListUomResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListUomResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListUomResponseOkResponse>(<any>null);
    }
}

export class ScenarioServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add new scenario (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    add(body: AddScenarioRequest | undefined , signal?: AbortSignal): Promise<AddScenarioResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd(_response);
        });
    }

    protected processAdd(response: AxiosResponse): Promise<AddScenarioResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddScenarioResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddScenarioResponseOkResponse>(<any>null);
    }

    /**
     * Update scenario (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    update(body: EditScenarioRequest | undefined , signal?: AbortSignal): Promise<EditScenarioResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate(_response);
        });
    }

    protected processUpdate(response: AxiosResponse): Promise<EditScenarioResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditScenarioResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditScenarioResponseOkResponse>(<any>null);
    }

    /**
     * Get scenario count by status (Auth policies: AdminPolicy)
     * @return OK
     */
    count(status: number , signal?: AbortSignal): Promise<ScenarioCountResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/count/{status}";
        if (status === undefined || status === null)
            throw new Error("The parameter 'status' must be defined.");
        url_ = url_.replace("{status}", encodeURIComponent("" + status));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processCount(_response);
        });
    }

    protected processCount(response: AxiosResponse): Promise<ScenarioCountResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioCountResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioCountResponseOkResponse>(<any>null);
    }

    /**
     * Delete scenarios (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    deleteScenario(body: DeleteRequest | undefined , signal?: AbortSignal): Promise<DeleteResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteScenario(_response);
        });
    }

    protected processDeleteScenario(response: AxiosResponse): Promise<DeleteResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteResponseOkResponse>(<any>null);
    }

    /**
     * Get scenario by id (Auth policies: AdminPolicy)
     * @return OK
     */
    get(id: number , signal?: AbortSignal): Promise<GetScenarioResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGet(_response);
        });
    }

    protected processGet(response: AxiosResponse): Promise<GetScenarioResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetScenarioResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetScenarioResponseOkResponse>(<any>null);
    }

    /**
     * Get all scenarios (Auth policies: AdminPolicy)
     * @param status (optional)
     * @param isMarked (optional)
     * @param sort_ScenarioField (optional) 1 = MTP_YEAR

    2 = REFERENCE_YEAR

    3 = NAME

    4 = STATUS

    5 = CREATED_BY_KID

    6 = CREATED_BY_NAME

    7 = CREATED_AT

    8 = UPDATED_AT
     * @param sort_Direction (optional) 0 = Ascending

    1 = Descending
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    list2(status: number | undefined, isMarked: boolean | null | undefined, sort_ScenarioField: SortableScenarioField | undefined, sort_Direction: ListSortDirection | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<ScenarioListResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/list?";
        if (status === null)
            throw new Error("The parameter 'status' cannot be null.");
        else if (status !== undefined)
            url_ += "status=" + encodeURIComponent("" + status) + "&";
        if (isMarked !== undefined && isMarked !== null)
            url_ += "isMarked=" + encodeURIComponent("" + isMarked) + "&";
        if (sort_ScenarioField === null)
            throw new Error("The parameter 'sort_ScenarioField' cannot be null.");
        else if (sort_ScenarioField !== undefined)
            url_ += "sort.ScenarioField=" + encodeURIComponent("" + sort_ScenarioField) + "&";
        if (sort_Direction === null)
            throw new Error("The parameter 'sort_Direction' cannot be null.");
        else if (sort_Direction !== undefined)
            url_ += "sort.Direction=" + encodeURIComponent("" + sort_Direction) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList2(_response);
        });
    }

    protected processList2(response: AxiosResponse): Promise<ScenarioListResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioListResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioListResponseOkResponse>(<any>null);
    }

    /**
     * Get all reporting occasions. (Auth policies: AdminPolicy)
     * @param term (optional)
     * @return OK
     */
    reportingOccasion(term: string | null | undefined , signal?: AbortSignal): Promise<ListReportingOccasionResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/reporting-occasion?";
        if (term !== undefined && term !== null)
            url_ += "term=" + encodeURIComponent("" + term) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processReportingOccasion(_response);
        });
    }

    protected processReportingOccasion(response: AxiosResponse): Promise<ListReportingOccasionResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListReportingOccasionResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListReportingOccasionResponseOkResponse>(<any>null);
    }

    /**
     * Mark scenarios (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    mark(body: MarkRequest | undefined , signal?: AbortSignal): Promise<MarkResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/mark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMark(_response);
        });
    }

    protected processMark(response: AxiosResponse): Promise<MarkResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkResponseOkResponse>(<any>null);
    }

    /**
     * Get scenario status distribution (Auth policies: AdminPolicy)
     * @param request (optional)
     * @return OK
     */
    statusDistribution(request: StatusDistributionRequest | undefined , signal?: AbortSignal): Promise<StatusDistributionResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/scenario/status-distribution?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStatusDistribution(_response);
        });
    }

    protected processStatusDistribution(response: AxiosResponse): Promise<StatusDistributionResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StatusDistributionResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StatusDistributionResponseOkResponse>(<any>null);
    }
}

export class MaintenanceCycleValuesServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Adds or deletes MaintenanceCycleValues for a scenario (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addMaintenanceCycleValues(body: AddMaintenanceCycleValuesRequest | undefined , signal?: AbortSignal): Promise<AddMaintenanceCycleValuesResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/maintenance-cycle-values/add-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddMaintenanceCycleValues(_response);
        });
    }

    protected processAddMaintenanceCycleValues(response: AxiosResponse): Promise<AddMaintenanceCycleValuesResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddMaintenanceCycleValuesResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddMaintenanceCycleValuesResponseOkResponse>(<any>null);
    }

    /**
     * List MaintenanceCycleValues for requested scenario (Auth policies: AdminPolicy)
     * @param plantSids (optional)
     * @param technologySids (optional)
     * @param countrySids (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    listMaintenanceCycleValues(scenarioId: number, plantSids: number[] | null | undefined, technologySids: number[] | null | undefined, countrySids: number[] | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<ListMaintenanceCycleValuesResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/maintenance-cycle-values/list/{scenarioId}?";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (plantSids !== undefined && plantSids !== null)
            plantSids && plantSids.forEach(item => { url_ += "PlantSids=" + encodeURIComponent("" + item) + "&"; });
        if (technologySids !== undefined && technologySids !== null)
            technologySids && technologySids.forEach(item => { url_ += "TechnologySids=" + encodeURIComponent("" + item) + "&"; });
        if (countrySids !== undefined && countrySids !== null)
            countrySids && countrySids.forEach(item => { url_ += "CountrySids=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListMaintenanceCycleValues(_response);
        });
    }

    protected processListMaintenanceCycleValues(response: AxiosResponse): Promise<ListMaintenanceCycleValuesResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListMaintenanceCycleValuesResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListMaintenanceCycleValuesResponseOkResponse>(<any>null);
    }
}

export class KpiServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add new kpi (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    add2(body: AddKpiRequest | undefined , signal?: AbortSignal): Promise<AddKpiResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAdd2(_response);
        });
    }

    protected processAdd2(response: AxiosResponse): Promise<AddKpiResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddKpiResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddKpiResponseOkResponse>(<any>null);
    }

    /**
     * Update kpi (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    update2(body: EditKpiRequest | undefined , signal?: AbortSignal): Promise<EditKpiResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUpdate2(_response);
        });
    }

    protected processUpdate2(response: AxiosResponse): Promise<EditKpiResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditKpiResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditKpiResponseOkResponse>(<any>null);
    }

    /**
     * Activate or deactivate kpis for a scenario. (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addActiveKpisToScenario(body: AddKpisToScenarioRequest | undefined , signal?: AbortSignal): Promise<AddKpisToScenarioResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi/add-active-kpis";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddActiveKpisToScenario(_response);
        });
    }

    protected processAddActiveKpisToScenario(response: AxiosResponse): Promise<AddKpisToScenarioResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddKpisToScenarioResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddKpisToScenarioResponseOkResponse>(<any>null);
    }

    /**
     * Delete kpi (Auth policies: AdminPolicy)
     * @param kpiId (optional)
     * @param scenrioId (optional)
     * @return OK
     */
    delete(kpiNumber: number, kpiId: string | null | undefined, scenrioId: number | undefined , signal?: AbortSignal): Promise<DeleteKpiResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi/{kpiNumber}?";
        if (kpiNumber === undefined || kpiNumber === null)
            throw new Error("The parameter 'kpiNumber' must be defined.");
        url_ = url_.replace("{kpiNumber}", encodeURIComponent("" + kpiNumber));
        if (kpiId !== undefined && kpiId !== null)
            url_ += "KpiId=" + encodeURIComponent("" + kpiId) + "&";
        if (scenrioId === null)
            throw new Error("The parameter 'scenrioId' cannot be null.");
        else if (scenrioId !== undefined)
            url_ += "ScenrioId=" + encodeURIComponent("" + scenrioId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "DELETE",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDelete(_response);
        });
    }

    protected processDelete(response: AxiosResponse): Promise<DeleteKpiResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteKpiResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteKpiResponseOkResponse>(<any>null);
    }

    /**
     * Import kpis from a previous scenario  (Auth policies: AdminPolicy)
     * @return OK
     */
    importKpiFromScenario(currentScenarioId: number, previousScenarioId: number , signal?: AbortSignal): Promise<ImportKpiFromScenarioResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi/import/{currentScenarioId}/{previousScenarioId}";
        if (currentScenarioId === undefined || currentScenarioId === null)
            throw new Error("The parameter 'currentScenarioId' must be defined.");
        url_ = url_.replace("{currentScenarioId}", encodeURIComponent("" + currentScenarioId));
        if (previousScenarioId === undefined || previousScenarioId === null)
            throw new Error("The parameter 'previousScenarioId' must be defined.");
        url_ = url_.replace("{previousScenarioId}", encodeURIComponent("" + previousScenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processImportKpiFromScenario(_response);
        });
    }

    protected processImportKpiFromScenario(response: AxiosResponse): Promise<ImportKpiFromScenarioResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ImportKpiFromScenarioResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ImportKpiFromScenarioResponseOkResponse>(<any>null);
    }

    /**
     * Get all kpis (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param isPrimary (optional)
     * @param kpiType (optional)
     * @param kpiActive (optional)
     * @param sort_Field (optional) 1 = KPI_TYPE

    2 = KPI_ID

    3 = KPI_DESC
     * @param sort_Direction (optional) 0 = Ascending

    1 = Descending
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    list4(scenarioId: number | undefined, isPrimary: boolean | null | undefined, kpiType: number[] | null | undefined, kpiActive: boolean | null | undefined, sort_Field: SortableKpiField | undefined, sort_Direction: ListSortDirection | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<KpiListResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi/list?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (isPrimary !== undefined && isPrimary !== null)
            url_ += "isPrimary=" + encodeURIComponent("" + isPrimary) + "&";
        if (kpiType !== undefined && kpiType !== null)
            kpiType && kpiType.forEach(item => { url_ += "kpiType=" + encodeURIComponent("" + item) + "&"; });
        if (kpiActive !== undefined && kpiActive !== null)
            url_ += "kpiActive=" + encodeURIComponent("" + kpiActive) + "&";
        if (sort_Field === null)
            throw new Error("The parameter 'sort_Field' cannot be null.");
        else if (sort_Field !== undefined)
            url_ += "sort.Field=" + encodeURIComponent("" + sort_Field) + "&";
        if (sort_Direction === null)
            throw new Error("The parameter 'sort_Direction' cannot be null.");
        else if (sort_Direction !== undefined)
            url_ += "sort.Direction=" + encodeURIComponent("" + sort_Direction) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList4(_response);
        });
    }

    protected processList4(response: AxiosResponse): Promise<KpiListResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KpiListResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KpiListResponseOkResponse>(<any>null);
    }

    /**
     * Get summary for kpis (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param isPrimary (optional)
     * @return OK
     */
    summary2(scenarioId: number | undefined, isPrimary: boolean | undefined , signal?: AbortSignal): Promise<SummaryResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi/summary?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (isPrimary === null)
            throw new Error("The parameter 'isPrimary' cannot be null.");
        else if (isPrimary !== undefined)
            url_ += "isPrimary=" + encodeURIComponent("" + isPrimary) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummary2(_response);
        });
    }

    protected processSummary2(response: AxiosResponse): Promise<SummaryResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = SummaryResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<SummaryResponseOkResponse>(<any>null);
    }
}

export class BudgetRequestServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add budget requests (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addBudget(body: AddBudgetsRequest | undefined , signal?: AbortSignal): Promise<AddBudgetsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/budget-request/add";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddBudget(_response);
        });
    }

    protected processAddBudget(response: AxiosResponse): Promise<AddBudgetsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddBudgetsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddBudgetsResponseOkResponse>(<any>null);
    }

    /**
     * Edit budget requests (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    editBudget(body: EditBudgetsRequest | undefined , signal?: AbortSignal): Promise<EditBudgetsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/budget-request/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditBudget(_response);
        });
    }

    protected processEditBudget(response: AxiosResponse): Promise<EditBudgetsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditBudgetsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditBudgetsResponseOkResponse>(<any>null);
    }

    /**
     * Get budget requests (Auth policies: AdminPolicy)
     * @param plantSids (optional)
     * @param countrySids (optional)
     * @param technologySids (optional)
     * @param operationTypes (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    getBudget(scenarioId: number, plantSids: number[] | null | undefined, countrySids: number[] | null | undefined, technologySids: number[] | null | undefined, operationTypes: number[] | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<GetBudgetResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/budget-request/get/{scenarioId}?";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (plantSids !== undefined && plantSids !== null)
            plantSids && plantSids.forEach(item => { url_ += "plantSids=" + encodeURIComponent("" + item) + "&"; });
        if (countrySids !== undefined && countrySids !== null)
            countrySids && countrySids.forEach(item => { url_ += "countrySids=" + encodeURIComponent("" + item) + "&"; });
        if (technologySids !== undefined && technologySids !== null)
            technologySids && technologySids.forEach(item => { url_ += "technologySids=" + encodeURIComponent("" + item) + "&"; });
        if (operationTypes !== undefined && operationTypes !== null)
            operationTypes && operationTypes.forEach(item => { url_ += "operationTypes=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudget(_response);
        });
    }

    protected processGetBudget(response: AxiosResponse): Promise<GetBudgetResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetResponseOkResponse>(<any>null);
    }

    /**
     * View budget request cost modifications (Auth policies: AdminPolicy)
     * @return OK
     */
    viewBudget(budgetRequestId: number , signal?: AbortSignal): Promise<ViewResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/budget-request/view/{budgetRequestId}";
        if (budgetRequestId === undefined || budgetRequestId === null)
            throw new Error("The parameter 'budgetRequestId' must be defined.");
        url_ = url_.replace("{budgetRequestId}", encodeURIComponent("" + budgetRequestId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processViewBudget(_response);
        });
    }

    protected processViewBudget(response: AxiosResponse): Promise<ViewResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ViewResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ViewResponseOkResponse>(<any>null);
    }
}

export class InflationServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add or update inflation (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addInflation(body: AddInflationRequest | undefined , signal?: AbortSignal): Promise<AddInflationResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/inflation/add-update";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddInflation(_response);
        });
    }

    protected processAddInflation(response: AxiosResponse): Promise<AddInflationResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddInflationResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddInflationResponseOkResponse>(<any>null);
    }

    /**
     * Get all inflations (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param isNominated (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    list5(scenarioId: number | undefined, isNominated: boolean | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<InflationListResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/inflation/list?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (isNominated === null)
            throw new Error("The parameter 'isNominated' cannot be null.");
        else if (isNominated !== undefined)
            url_ += "isNominated=" + encodeURIComponent("" + isNominated) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList5(_response);
        });
    }

    protected processList5(response: AxiosResponse): Promise<InflationListResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = InflationListResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<InflationListResponseOkResponse>(<any>null);
    }
}

export class KpiTypeServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add new kpi type (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addKpiType(body: AddKpiTypeRequest | undefined , signal?: AbortSignal): Promise<AddKpiTypeResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddKpiType(_response);
        });
    }

    protected processAddKpiType(response: AxiosResponse): Promise<AddKpiTypeResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddKpiTypeResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddKpiTypeResponseOkResponse>(<any>null);
    }

    /**
     * Delete kpi types (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    deleteKpiType(body: DeleteKpiTypeRequest | undefined , signal?: AbortSignal): Promise<DeleteKpiTypeResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "DELETE",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteKpiType(_response);
        });
    }

    protected processDeleteKpiType(response: AxiosResponse): Promise<DeleteKpiTypeResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteKpiTypeResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteKpiTypeResponseOkResponse>(<any>null);
    }

    /**
     * Edit the kpi types (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    editKpiType(body: EditKpiTypeRequest | undefined , signal?: AbortSignal): Promise<EditKpiTypeResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi-type";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditKpiType(_response);
        });
    }

    protected processEditKpiType(response: AxiosResponse): Promise<EditKpiTypeResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditKpiTypeResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditKpiTypeResponseOkResponse>(<any>null);
    }

    /**
     * Get kpi types (Auth policies: AdminPolicy)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    listKpiTypes(page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<ListKpiTypeResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/kpi-type?";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListKpiTypes(_response);
        });
    }

    protected processListKpiTypes(response: AxiosResponse): Promise<ListKpiTypeResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListKpiTypeResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListKpiTypeResponseOkResponse>(<any>null);
    }
}

export class UnitServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Add or delete units (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    addUnit(body: AddUnitsRequest | undefined , signal?: AbortSignal): Promise<AddUnitsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/units/add-delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processAddUnit(_response);
        });
    }

    protected processAddUnit(response: AxiosResponse): Promise<AddUnitsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = AddUnitsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<AddUnitsResponseOkResponse>(<any>null);
    }

    /**
     * Get all units (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param technologies (optional)
     * @param countries (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    list(scenarioId: number | undefined, technologies: number[] | null | undefined, countries: number[] | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<UnitsListResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/units/list?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (technologies !== undefined && technologies !== null)
            technologies && technologies.forEach(item => { url_ += "technologies=" + encodeURIComponent("" + item) + "&"; });
        if (countries !== undefined && countries !== null)
            countries && countries.forEach(item => { url_ += "countries=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList(_response);
        });
    }

    protected processList(response: AxiosResponse): Promise<UnitsListResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UnitsListResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UnitsListResponseOkResponse>(<any>null);
    }
}

export class ResultServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get asset filters for reports. (Auth policies: AdminPolicy)
     * @param scenarioIds (optional)
     * @param getKpiTypes (optional)
     * @return OK
     */
    filter(scenarioIds: number[] | null | undefined, getKpiTypes: boolean | undefined , signal?: AbortSignal): Promise<GetFiltersResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/result/filter?";
        if (scenarioIds !== undefined && scenarioIds !== null)
            scenarioIds && scenarioIds.forEach(item => { url_ += "scenarioIds=" + encodeURIComponent("" + item) + "&"; });
        if (getKpiTypes === null)
            throw new Error("The parameter 'getKpiTypes' cannot be null.");
        else if (getKpiTypes !== undefined)
            url_ += "getKpiTypes=" + encodeURIComponent("" + getKpiTypes) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processFilter(_response);
        });
    }

    protected processFilter(response: AxiosResponse): Promise<GetFiltersResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetFiltersResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetFiltersResponseOkResponse>(<any>null);
    }
}

export class MaintenancesServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get registered type maps
     * @return OK
     */
    getAutoMapperTypeMaps(  signal?: AbortSignal): Promise<MaintenanceAutoMapperTypeMapsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/maintenance/automapper-type-maps";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAutoMapperTypeMaps(_response);
        });
    }

    protected processGetAutoMapperTypeMaps(response: AxiosResponse): Promise<MaintenanceAutoMapperTypeMapsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MaintenanceAutoMapperTypeMapsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MaintenanceAutoMapperTypeMapsResponseOkResponse>(<any>null);
    }

    /**
     * Get registered services
     * @return OK
     */
    getRegisteredServices(  signal?: AbortSignal): Promise<RegisteredServicesResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/maintenance/registered-services";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetRegisteredServices(_response);
        });
    }

    protected processGetRegisteredServices(response: AxiosResponse): Promise<RegisteredServicesResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = RegisteredServicesResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<RegisteredServicesResponseOkResponse>(<any>null);
    }
}

export class DevServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Delete test scenarios (Auth)
     * @param body (optional)
     * @return OK
     */
    deleteTestScenarios(body: DeleteTestDataRequest | undefined , signal?: AbortSignal): Promise<DeleteTestDataResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/dev/delete";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processDeleteTestScenarios(_response);
        });
    }

    protected processDeleteTestScenarios(response: AxiosResponse): Promise<DeleteTestDataResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = DeleteTestDataResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<DeleteTestDataResponseOkResponse>(<any>null);
    }
}

export class CostCoefficientsServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Edit CostCoefficients for a scenario (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    editCostCoefficients(body: EditCostCoefficientRequest | undefined , signal?: AbortSignal): Promise<EditCostCoefficientResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/cost-coefficients";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "PUT",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditCostCoefficients(_response);
        });
    }

    protected processEditCostCoefficients(response: AxiosResponse): Promise<EditCostCoefficientResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditCostCoefficientResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditCostCoefficientResponseOkResponse>(<any>null);
    }

    /**
     * List CostCoefficients for a scenario (Auth policies: AdminPolicy)
     * @param kpiIds (optional)
     * @param plantSids (optional)
     * @param technologySids (optional)
     * @param countrySids (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    listCostCoefficients(scenarioId: number, kpiIds: string[] | null | undefined, plantSids: number[] | null | undefined, technologySids: number[] | null | undefined, countrySids: number[] | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<ListCostCoefficientsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/cost-coefficients/list/{scenarioId}?";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (kpiIds !== undefined && kpiIds !== null)
            kpiIds && kpiIds.forEach(item => { url_ += "KpiIds=" + encodeURIComponent("" + item) + "&"; });
        if (plantSids !== undefined && plantSids !== null)
            plantSids && plantSids.forEach(item => { url_ += "PlantSids=" + encodeURIComponent("" + item) + "&"; });
        if (technologySids !== undefined && technologySids !== null)
            technologySids && technologySids.forEach(item => { url_ += "TechnologySids=" + encodeURIComponent("" + item) + "&"; });
        if (countrySids !== undefined && countrySids !== null)
            countrySids && countrySids.forEach(item => { url_ += "CountrySids=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListCostCoefficients(_response);
        });
    }

    protected processListCostCoefficients(response: AxiosResponse): Promise<ListCostCoefficientsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListCostCoefficientsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListCostCoefficientsResponseOkResponse>(<any>null);
    }
}

export class PrimaryDataServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Edit primary kpi data. (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    editPrimaryData(body: EditPrimaryKpiRequest | undefined , signal?: AbortSignal): Promise<EditPrimaryKpiResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/primary-data-kpi/edit";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processEditPrimaryData(_response);
        });
    }

    protected processEditPrimaryData(response: AxiosResponse): Promise<EditPrimaryKpiResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EditPrimaryKpiResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EditPrimaryKpiResponseOkResponse>(<any>null);
    }

    /**
     * Export kpi primary data per scenario (Auth policies: AdminPolicy)
     * @param id Scenario id.
     * @param showMissingValues (optional)
     * @param kpiType (optional)
     * @param technologySid (optional)
     * @param unitSid (optional)
     * @param plantSid (optional)
     * @param years (optional)
     * @param countrySid (optional)
     * @param sort_PrimaryDataField (optional) 1 = KPI_ID (FORMULA.KPI_ID)

    2 = NAME (names.NAME)
     * @param sort_Direction (optional) 0 = Ascending

    1 = Descending
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return Success
     */
    exportPrimaryData(id: number, showMissingValues: boolean | undefined, kpiType: number[] | null | undefined, technologySid: number[] | null | undefined, unitSid: number[] | null | undefined, plantSid: number[] | null | undefined, years: number[] | null | undefined, countrySid: number[] | null | undefined, sort_PrimaryDataField: SortablePrimaryDataField | undefined, sort_Direction: ListSortDirection | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<void> {
        let url_ = this.baseUrl + "/api/v1/primary-data-kpi/export/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (showMissingValues === null)
            throw new Error("The parameter 'showMissingValues' cannot be null.");
        else if (showMissingValues !== undefined)
            url_ += "showMissingValues=" + encodeURIComponent("" + showMissingValues) + "&";
        if (kpiType !== undefined && kpiType !== null)
            kpiType && kpiType.forEach(item => { url_ += "kpiType=" + encodeURIComponent("" + item) + "&"; });
        if (technologySid !== undefined && technologySid !== null)
            technologySid && technologySid.forEach(item => { url_ += "technologySid=" + encodeURIComponent("" + item) + "&"; });
        if (unitSid !== undefined && unitSid !== null)
            unitSid && unitSid.forEach(item => { url_ += "unitSid=" + encodeURIComponent("" + item) + "&"; });
        if (plantSid !== undefined && plantSid !== null)
            plantSid && plantSid.forEach(item => { url_ += "plantSid=" + encodeURIComponent("" + item) + "&"; });
        if (years !== undefined && years !== null)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (countrySid !== undefined && countrySid !== null)
            countrySid && countrySid.forEach(item => { url_ += "countrySid=" + encodeURIComponent("" + item) + "&"; });
        if (sort_PrimaryDataField === null)
            throw new Error("The parameter 'sort_PrimaryDataField' cannot be null.");
        else if (sort_PrimaryDataField !== undefined)
            url_ += "sort.PrimaryDataField=" + encodeURIComponent("" + sort_PrimaryDataField) + "&";
        if (sort_Direction === null)
            throw new Error("The parameter 'sort_Direction' cannot be null.");
        else if (sort_Direction !== undefined)
            url_ += "sort.Direction=" + encodeURIComponent("" + sort_Direction) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processExportPrimaryData(_response);
        });
    }

    protected processExportPrimaryData(response: AxiosResponse): Promise<void> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            return Promise.resolve<void>(<any>null);
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<void>(<any>null);
    }

    /**
     * Get kpi primary data (Auth policies: AdminPolicy)
     * @param id Scenario id.
     * @param showMissingValues (optional)
     * @param kpiType (optional)
     * @param technologySid (optional)
     * @param unitSid (optional)
     * @param plantSid (optional)
     * @param years (optional)
     * @param countrySid (optional)
     * @param sort_PrimaryDataField (optional) 1 = KPI_ID (FORMULA.KPI_ID)

    2 = NAME (names.NAME)
     * @param sort_Direction (optional) 0 = Ascending

    1 = Descending
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    list3(id: number, showMissingValues: boolean | undefined, kpiType: number[] | null | undefined, technologySid: number[] | null | undefined, unitSid: number[] | null | undefined, plantSid: number[] | null | undefined, years: number[] | null | undefined, countrySid: number[] | null | undefined, sort_PrimaryDataField: SortablePrimaryDataField | undefined, sort_Direction: ListSortDirection | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<PrimaryDataListResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/primary-data-kpi/list/{id}?";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        if (showMissingValues === null)
            throw new Error("The parameter 'showMissingValues' cannot be null.");
        else if (showMissingValues !== undefined)
            url_ += "showMissingValues=" + encodeURIComponent("" + showMissingValues) + "&";
        if (kpiType !== undefined && kpiType !== null)
            kpiType && kpiType.forEach(item => { url_ += "kpiType=" + encodeURIComponent("" + item) + "&"; });
        if (technologySid !== undefined && technologySid !== null)
            technologySid && technologySid.forEach(item => { url_ += "technologySid=" + encodeURIComponent("" + item) + "&"; });
        if (unitSid !== undefined && unitSid !== null)
            unitSid && unitSid.forEach(item => { url_ += "unitSid=" + encodeURIComponent("" + item) + "&"; });
        if (plantSid !== undefined && plantSid !== null)
            plantSid && plantSid.forEach(item => { url_ += "plantSid=" + encodeURIComponent("" + item) + "&"; });
        if (years !== undefined && years !== null)
            years && years.forEach(item => { url_ += "years=" + encodeURIComponent("" + item) + "&"; });
        if (countrySid !== undefined && countrySid !== null)
            countrySid && countrySid.forEach(item => { url_ += "countrySid=" + encodeURIComponent("" + item) + "&"; });
        if (sort_PrimaryDataField === null)
            throw new Error("The parameter 'sort_PrimaryDataField' cannot be null.");
        else if (sort_PrimaryDataField !== undefined)
            url_ += "sort.PrimaryDataField=" + encodeURIComponent("" + sort_PrimaryDataField) + "&";
        if (sort_Direction === null)
            throw new Error("The parameter 'sort_Direction' cannot be null.");
        else if (sort_Direction !== undefined)
            url_ += "sort.Direction=" + encodeURIComponent("" + sort_Direction) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList3(_response);
        });
    }

    protected processList3(response: AxiosResponse): Promise<PrimaryDataListResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrimaryDataListResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrimaryDataListResponseOkResponse>(<any>null);
    }

    /**
     * Get etl logs for scenario. (Auth policies: AdminPolicy)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    listEtlLogs(scenarioId: number, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<ListEtlLogsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/primary-data-kpi/logs/{scenarioId}?";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processListEtlLogs(_response);
        });
    }

    protected processListEtlLogs(response: AxiosResponse): Promise<ListEtlLogsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ListEtlLogsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ListEtlLogsResponseOkResponse>(<any>null);
    }

    /**
     * Get primary data summary (Auth policies: AdminPolicy)
     * @param id Scenario id.
     * @return OK
     */
    summary(id: number , signal?: AbortSignal): Promise<PrimaryDataSummaryResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/primary-data-kpi/summary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummary(_response);
        });
    }

    protected processSummary(response: AxiosResponse): Promise<PrimaryDataSummaryResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PrimaryDataSummaryResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PrimaryDataSummaryResponseOkResponse>(<any>null);
    }

    /**
     * Upload primary kpi data. (Auth policies: AdminPolicy)
     * @param file (optional)
     * @param scenarioId (optional)
     * @return OK
     */
    uploadPrimaryData(file: FileParameter | null | undefined, scenarioId: number | undefined , signal?: AbortSignal): Promise<UploadPrimaryDataResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/primary-data-kpi/upload";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = new FormData();
        if (file !== null && file !== undefined)
            content_.append("File", file.data, file.fileName ? file.fileName : "File");
        if (scenarioId === null || scenarioId === undefined)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else
            content_.append("ScenarioId", scenarioId.toString());

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processUploadPrimaryData(_response);
        });
    }

    protected processUploadPrimaryData(response: AxiosResponse): Promise<UploadPrimaryDataResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = UploadPrimaryDataResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<UploadPrimaryDataResponseOkResponse>(<any>null);
    }
}

export class PmlServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get budgets in mtp year (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param plantSids (optional)
     * @param technologySids (optional)
     * @param countrySids (optional)
     * @param hasValues (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    getBudgets(scenarioId: number | undefined, plantSids: number[] | null | undefined, technologySids: number[] | null | undefined, countrySids: number[] | null | undefined, hasValues: boolean | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<GetBudgetsInMtpYearResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/pml/budgets?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "ScenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (plantSids !== undefined && plantSids !== null)
            plantSids && plantSids.forEach(item => { url_ += "PlantSids=" + encodeURIComponent("" + item) + "&"; });
        if (technologySids !== undefined && technologySids !== null)
            technologySids && technologySids.forEach(item => { url_ += "TechnologySids=" + encodeURIComponent("" + item) + "&"; });
        if (countrySids !== undefined && countrySids !== null)
            countrySids && countrySids.forEach(item => { url_ += "CountrySids=" + encodeURIComponent("" + item) + "&"; });
        if (hasValues !== undefined && hasValues !== null)
            url_ += "HasValues=" + encodeURIComponent("" + hasValues) + "&";
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetBudgets(_response);
        });
    }

    protected processGetBudgets(response: AxiosResponse): Promise<GetBudgetsInMtpYearResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetBudgetsInMtpYearResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetBudgetsInMtpYearResponseOkResponse>(<any>null);
    }

    /**
     * Get mtp years (Auth policies: AdminPolicy)
     * @param request (optional)
     * @return OK
     */
    getMtps(request: GetPmlMtpsRequest | undefined , signal?: AbortSignal): Promise<GetPmlMtpsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/pml/mtps?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetMtps(_response);
        });
    }

    protected processGetMtps(response: AxiosResponse): Promise<GetPmlMtpsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetPmlMtpsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetPmlMtpsResponseOkResponse>(<any>null);
    }
}

export class SiteViewServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get kpi report by kpi id and unit ids (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param kpiId (optional)
     * @param startYear (optional)
     * @param endYear (optional)
     * @param units (optional)
     * @return OK
     */
    kpiReport(scenarioId: number | undefined, kpiId: string | null | undefined, startYear: number | undefined, endYear: number | undefined, units: number[] | null | undefined , signal?: AbortSignal): Promise<GetKpiReportResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/site-view/kpi-report?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (kpiId !== undefined && kpiId !== null)
            url_ += "kpiId=" + encodeURIComponent("" + kpiId) + "&";
        if (startYear === null)
            throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined)
            url_ += "startYear=" + encodeURIComponent("" + startYear) + "&";
        if (endYear === null)
            throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined)
            url_ += "endYear=" + encodeURIComponent("" + endYear) + "&";
        if (units !== undefined && units !== null)
            units && units.forEach(item => { url_ += "units=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKpiReport(_response);
        });
    }

    protected processKpiReport(response: AxiosResponse): Promise<GetKpiReportResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetKpiReportResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetKpiReportResponseOkResponse>(<any>null);
    }

    /**
     * Get data for trend reports (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param startYear (optional)
     * @param endYear (optional)
     * @param units (optional)
     * @return OK
     */
    trendReports(scenarioId: number | undefined, startYear: number | undefined, endYear: number | undefined, units: number[] | null | undefined , signal?: AbortSignal): Promise<GetTrendReportsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/site-view/trend-reports?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "scenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (startYear === null)
            throw new Error("The parameter 'startYear' cannot be null.");
        else if (startYear !== undefined)
            url_ += "startYear=" + encodeURIComponent("" + startYear) + "&";
        if (endYear === null)
            throw new Error("The parameter 'endYear' cannot be null.");
        else if (endYear !== undefined)
            url_ += "endYear=" + encodeURIComponent("" + endYear) + "&";
        if (units !== undefined && units !== null)
            units && units.forEach(item => { url_ += "units=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processTrendReports(_response);
        });
    }

    protected processTrendReports(response: AxiosResponse): Promise<GetTrendReportsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = GetTrendReportsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<GetTrendReportsResponseOkResponse>(<any>null);
    }
}

export class RunResultServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get kpi analysis tree data (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param kpiId (optional)
     * @param year (optional)
     * @param unitSid (optional)
     * @return OK
     */
    kpiAnalysis(scenarioId: number | undefined, kpiId: string | null | undefined, year: number | undefined, unitSid: number | undefined , signal?: AbortSignal): Promise<KpiAnalysisResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/run-result/kpi-analysis?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "ScenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (kpiId !== undefined && kpiId !== null)
            url_ += "KpiId=" + encodeURIComponent("" + kpiId) + "&";
        if (year === null)
            throw new Error("The parameter 'year' cannot be null.");
        else if (year !== undefined)
            url_ += "Year=" + encodeURIComponent("" + year) + "&";
        if (unitSid === null)
            throw new Error("The parameter 'unitSid' cannot be null.");
        else if (unitSid !== undefined)
            url_ += "UnitSid=" + encodeURIComponent("" + unitSid) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processKpiAnalysis(_response);
        });
    }

    protected processKpiAnalysis(response: AxiosResponse): Promise<KpiAnalysisResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = KpiAnalysisResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<KpiAnalysisResponseOkResponse>(<any>null);
    }

    /**
     * Get scenario run result comparison details (Auth policies: AdminPolicy)
     * @param firstScenarioId (optional)
     * @param secondScenarioId (optional)
     * @param machineSid (optional)
     * @param kpiId (optional)
     * @return OK
     */
    scenarioCompareDetails(firstScenarioId: number | undefined, secondScenarioId: number | undefined, machineSid: number | undefined, kpiId: string | null | undefined , signal?: AbortSignal): Promise<ScenarioCompareDetailsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/run-result/scenario-compare/details?";
        if (firstScenarioId === null)
            throw new Error("The parameter 'firstScenarioId' cannot be null.");
        else if (firstScenarioId !== undefined)
            url_ += "FirstScenarioId=" + encodeURIComponent("" + firstScenarioId) + "&";
        if (secondScenarioId === null)
            throw new Error("The parameter 'secondScenarioId' cannot be null.");
        else if (secondScenarioId !== undefined)
            url_ += "SecondScenarioId=" + encodeURIComponent("" + secondScenarioId) + "&";
        if (machineSid === null)
            throw new Error("The parameter 'machineSid' cannot be null.");
        else if (machineSid !== undefined)
            url_ += "MachineSid=" + encodeURIComponent("" + machineSid) + "&";
        if (kpiId !== undefined && kpiId !== null)
            url_ += "KpiId=" + encodeURIComponent("" + kpiId) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenarioCompareDetails(_response);
        });
    }

    protected processScenarioCompareDetails(response: AxiosResponse): Promise<ScenarioCompareDetailsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioCompareDetailsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioCompareDetailsResponseOkResponse>(<any>null);
    }

    /**
     * Get scenario run result comparison data (Auth policies: AdminPolicy)
     * @param firstScenarioId (optional)
     * @param secondScenarioId (optional)
     * @param machineSids (optional)
     * @param plantSids (optional)
     * @param countrySids (optional)
     * @param kpiTypeIds (optional)
     * @param kpiIds (optional)
     * @param statuses (optional)
     * @param isPrimaryKpiOnly (optional)
     * @return OK
     */
    scenarioCompareList(firstScenarioId: number | undefined, secondScenarioId: number | undefined, machineSids: number[] | null | undefined, plantSids: number[] | null | undefined, countrySids: number[] | null | undefined, kpiTypeIds: number[] | null | undefined, kpiIds: string[] | null | undefined, statuses: number[] | null | undefined, isPrimaryKpiOnly: boolean | undefined , signal?: AbortSignal): Promise<ScenarioCompareResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/run-result/scenario-compare/list?";
        if (firstScenarioId === null)
            throw new Error("The parameter 'firstScenarioId' cannot be null.");
        else if (firstScenarioId !== undefined)
            url_ += "FirstScenarioId=" + encodeURIComponent("" + firstScenarioId) + "&";
        if (secondScenarioId === null)
            throw new Error("The parameter 'secondScenarioId' cannot be null.");
        else if (secondScenarioId !== undefined)
            url_ += "SecondScenarioId=" + encodeURIComponent("" + secondScenarioId) + "&";
        if (machineSids !== undefined && machineSids !== null)
            machineSids && machineSids.forEach(item => { url_ += "MachineSids=" + encodeURIComponent("" + item) + "&"; });
        if (plantSids !== undefined && plantSids !== null)
            plantSids && plantSids.forEach(item => { url_ += "PlantSids=" + encodeURIComponent("" + item) + "&"; });
        if (countrySids !== undefined && countrySids !== null)
            countrySids && countrySids.forEach(item => { url_ += "CountrySids=" + encodeURIComponent("" + item) + "&"; });
        if (kpiTypeIds !== undefined && kpiTypeIds !== null)
            kpiTypeIds && kpiTypeIds.forEach(item => { url_ += "KpiTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (kpiIds !== undefined && kpiIds !== null)
            kpiIds && kpiIds.forEach(item => { url_ += "KpiIds=" + encodeURIComponent("" + item) + "&"; });
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "Statuses=" + encodeURIComponent("" + item) + "&"; });
        if (isPrimaryKpiOnly === null)
            throw new Error("The parameter 'isPrimaryKpiOnly' cannot be null.");
        else if (isPrimaryKpiOnly !== undefined)
            url_ += "IsPrimaryKpiOnly=" + encodeURIComponent("" + isPrimaryKpiOnly) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processScenarioCompareList(_response);
        });
    }

    protected processScenarioCompareList(response: AxiosResponse): Promise<ScenarioCompareResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = ScenarioCompareResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<ScenarioCompareResponseOkResponse>(<any>null);
    }
}

export class FiltersServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get filters tabs (Auth policies: AdminPolicy)
     * @return OK
     */
    list6(scenarioId: number , signal?: AbortSignal): Promise<FilterResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/filter/list/{scenarioId}";
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList6(_response);
        });
    }

    protected processList6(response: AxiosResponse): Promise<FilterResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = FilterResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<FilterResponseOkResponse>(<any>null);
    }
}

export class EngineRunServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get all scenarios with status EngineRunCompleted (Auth policies: AdminPolicy)
     * @param sort_EngineRunField (optional) 0 = NAME

    1 = Started_By

    2 = Created_Updated
     * @param sort_Direction (optional) 0 = Ascending

    1 = Descending
     * @param statuses (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    list7(sort_EngineRunField: SortableEngineRunField | undefined, sort_Direction: ListSortDirection | undefined, statuses: number[] | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<EngineRunListResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/list?";
        if (sort_EngineRunField === null)
            throw new Error("The parameter 'sort_EngineRunField' cannot be null.");
        else if (sort_EngineRunField !== undefined)
            url_ += "sort.EngineRunField=" + encodeURIComponent("" + sort_EngineRunField) + "&";
        if (sort_Direction === null)
            throw new Error("The parameter 'sort_Direction' cannot be null.");
        else if (sort_Direction !== undefined)
            url_ += "sort.Direction=" + encodeURIComponent("" + sort_Direction) + "&";
        if (statuses !== undefined && statuses !== null)
            statuses && statuses.forEach(item => { url_ += "statuses=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processList7(_response);
        });
    }

    protected processList7(response: AxiosResponse): Promise<EngineRunListResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EngineRunListResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EngineRunListResponseOkResponse>(<any>null);
    }

    /**
     * Mark errors as acceptable (Auth policies: AdminPolicy)
     * @param body (optional)
     * @return OK
     */
    markError(body: MarkErrorRequest | undefined , signal?: AbortSignal): Promise<MarkErrorResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/mark";
        url_ = url_.replace(/[?&]$/, "");

        const content_ = JSON.stringify(body);

        let options_ = <AxiosRequestConfig>{
            data: content_,
            method: "POST",
            url: url_,
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processMarkError(_response);
        });
    }

    protected processMarkError(response: AxiosResponse): Promise<MarkErrorResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MarkErrorResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MarkErrorResponseOkResponse>(<any>null);
    }

    /**
     * Start engine run (Auth policies: AdminPolicy)
     * @return OK
     */
    start(id: number , signal?: AbortSignal): Promise<StartEngineRunResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/start/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStart(_response);
        });
    }

    protected processStart(response: AxiosResponse): Promise<StartEngineRunResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StartEngineRunResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StartEngineRunResponseOkResponse>(<any>null);
    }

    /**
     * Stop engine run (Auth policies: AdminPolicy)
     * @return OK
     */
    stop(taskName: string | null, scenarioId: number , signal?: AbortSignal): Promise<StopEngineRunResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/stop/{taskName}/{scenarioId}";
        if (taskName === undefined || taskName === null)
            throw new Error("The parameter 'taskName' must be defined.");
        url_ = url_.replace("{taskName}", encodeURIComponent("" + taskName));
        if (scenarioId === undefined || scenarioId === null)
            throw new Error("The parameter 'scenarioId' must be defined.");
        url_ = url_.replace("{scenarioId}", encodeURIComponent("" + scenarioId));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStop(_response);
        });
    }

    protected processStop(response: AxiosResponse): Promise<StopEngineRunResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StopEngineRunResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopEngineRunResponseOkResponse>(<any>null);
    }

    /**
     * Stop all engine run (Auth policies: AdminPolicy)
     * @param request (optional)
     * @return OK
     */
    stopAll(request: StopAllEngineRunRequest | undefined , signal?: AbortSignal): Promise<StopAllEngineRunResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/stop-all?";
        if (request === null)
            throw new Error("The parameter 'request' cannot be null.");
        else if (request !== undefined)
            url_ += "request=" + encodeURIComponent("" + request) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processStopAll(_response);
        });
    }

    protected processStopAll(response: AxiosResponse): Promise<StopAllEngineRunResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = StopAllEngineRunResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<StopAllEngineRunResponseOkResponse>(<any>null);
    }

    /**
     * Get summary for engine run for a scenario (Auth policies: AdminPolicy)
     * @return OK
     */
    summary3(id: number , signal?: AbortSignal): Promise<EngineRunSummaryResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/summary/{id}";
        if (id === undefined || id === null)
            throw new Error("The parameter 'id' must be defined.");
        url_ = url_.replace("{id}", encodeURIComponent("" + id));
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processSummary3(_response);
        });
    }

    protected processSummary3(response: AxiosResponse): Promise<EngineRunSummaryResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EngineRunSummaryResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EngineRunSummaryResponseOkResponse>(<any>null);
    }

    /**
     * Get all engine run logs for a scenario (Auth policies: AdminPolicy)
     * @param scenarioId (optional)
     * @param logMessageLevels (optional)
     * @param page (optional)
     * @param size (optional)
     * @param term (optional)
     * @param termToLower (optional)
     * @return OK
     */
    viewDetails(scenarioId: number | undefined, logMessageLevels: number[] | null | undefined, page: number | undefined, size: number | undefined, term: string | null | undefined, termToLower: string | null | undefined , signal?: AbortSignal): Promise<EngineRunDetailsResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/engine-run/view?";
        if (scenarioId === null)
            throw new Error("The parameter 'scenarioId' cannot be null.");
        else if (scenarioId !== undefined)
            url_ += "ScenarioId=" + encodeURIComponent("" + scenarioId) + "&";
        if (logMessageLevels !== undefined && logMessageLevels !== null)
            logMessageLevels && logMessageLevels.forEach(item => { url_ += "LogMessageLevels=" + encodeURIComponent("" + item) + "&"; });
        if (page === null)
            throw new Error("The parameter 'page' cannot be null.");
        else if (page !== undefined)
            url_ += "page=" + encodeURIComponent("" + page) + "&";
        if (size === null)
            throw new Error("The parameter 'size' cannot be null.");
        else if (size !== undefined)
            url_ += "size=" + encodeURIComponent("" + size) + "&";
        if (term !== undefined && term !== null)
            url_ += "Term=" + encodeURIComponent("" + term) + "&";
        if (termToLower !== undefined && termToLower !== null)
            url_ += "TermToLower=" + encodeURIComponent("" + termToLower) + "&";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processViewDetails(_response);
        });
    }

    protected processViewDetails(response: AxiosResponse): Promise<EngineRunDetailsResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = EngineRunDetailsResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<EngineRunDetailsResponseOkResponse>(<any>null);
    }
}

export class MasterDataServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get atributes (Auth policies: AdminPolicy)
     * @param unitIds (optional)
     * @param plantIds (optional)
     * @param unitTypeIds (optional)
     * @param countryIds (optional)
     * @return OK
     */
    getAtributes(moduleId: number, unitIds: number[] | null | undefined, plantIds: number[] | null | undefined, unitTypeIds: number[] | null | undefined, countryIds: number[] | null | undefined , signal?: AbortSignal): Promise<MasterDataGetAttributesResponseOkResponse> {
        let url_ = this.baseUrl + "/api/v1/master-data/atributes/{moduleId}?";
        if (moduleId === undefined || moduleId === null)
            throw new Error("The parameter 'moduleId' must be defined.");
        url_ = url_.replace("{moduleId}", encodeURIComponent("" + moduleId));
        if (unitIds !== undefined && unitIds !== null)
            unitIds && unitIds.forEach(item => { url_ += "UnitIds=" + encodeURIComponent("" + item) + "&"; });
        if (plantIds !== undefined && plantIds !== null)
            plantIds && plantIds.forEach(item => { url_ += "PlantIds=" + encodeURIComponent("" + item) + "&"; });
        if (unitTypeIds !== undefined && unitTypeIds !== null)
            unitTypeIds && unitTypeIds.forEach(item => { url_ += "UnitTypeIds=" + encodeURIComponent("" + item) + "&"; });
        if (countryIds !== undefined && countryIds !== null)
            countryIds && countryIds.forEach(item => { url_ += "CountryIds=" + encodeURIComponent("" + item) + "&"; });
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processGetAtributes(_response);
        });
    }

    protected processGetAtributes(response: AxiosResponse): Promise<MasterDataGetAttributesResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = MasterDataGetAttributesResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 401) {
            const _responseText = response.data;
            return throwException("Unauthorized", status, _responseText, _headers);
        } else if (status === 403) {
            const _responseText = response.data;
            return throwException("Forbidden", status, _responseText, _headers);
        } else if (status === 400) {
            const _responseText = response.data;
            let result400: any = null;
            let resultData400  = _responseText;
            result400 = BadRequestResponse.fromJS(resultData400);
            return throwException("Bad Request", status, _responseText, _headers, result400);
        } else if (status === 404) {
            const _responseText = response.data;
            let result404: any = null;
            let resultData404  = _responseText;
            result404 = NotFoundResponse.fromJS(resultData404);
            return throwException("Not Found", status, _responseText, _headers, result404);
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<MasterDataGetAttributesResponseOkResponse>(<any>null);
    }
}

export class PingServiceProxy {
    private instance: ApiConnection;
    private baseUrl: string;
    protected jsonParseReviver: ((key: string, value: any) => any) | undefined = undefined;

    constructor(instance?: ApiConnection) {
        this.instance = instance ? instance : new ApiConnection();
        this.baseUrl = ""; // this.baseUrl = baseUrl !== undefined && baseUrl !== null ? baseUrl : "";
    }

    /**
     * Get ping
     * @return OK
     */
    ping(  signal?: AbortSignal): Promise<PingGetResponseOkResponse> {
        let url_ = this.baseUrl + "/api/ping";
        url_ = url_.replace(/[?&]$/, "");

        let options_ = <AxiosRequestConfig>{
            method: "GET",
            url: url_,
            headers: {
                "Accept": "application/json"
            },
            signal
        };

        return this.instance.request(options_).catch((_error: any) => {
            if (isAxiosError(_error) && _error.response) {
                return _error.response;
            } else {
                throw _error;
            }
        }).then((_response: AxiosResponse) => {
            return this.processPing(_response);
        });
    }

    protected processPing(response: AxiosResponse): Promise<PingGetResponseOkResponse> {
        const status = response.status;
        let _headers: any = {};
        if (response.headers && typeof response.headers === "object") {
            for (let k in response.headers) {
                if (response.headers.hasOwnProperty(k)) {
                    _headers[k] = response.headers[k];
                }
            }
        }
        if (status === 200) {
            const _responseText = response.data;
            let result200: any = null;
            let resultData200  = _responseText;
            result200 = PingGetResponseOkResponse.fromJS(resultData200);
            return result200;
        } else if (status === 500) {
            const _responseText = response.data;
            let result500: any = null;
            let resultData500  = _responseText;
            result500 = InternalServerErrorResponse.fromJS(resultData500);
            return throwException("Internal Server Error", status, _responseText, _headers, result500);
        } else if (status === 429) {
            const _responseText = response.data;
            let result429: any = null;
            let resultData429  = _responseText;
            result429 = TooManyRequestsResponse.fromJS(resultData429);
            return throwException("Too Many Requests", status, _responseText, _headers, result429);
        } else if (status !== 200 && status !== 204) {
            const _responseText = response.data;
            return throwException("An unexpected server error occurred.", status, _responseText, _headers);
        }
        return Promise.resolve<PingGetResponseOkResponse>(<any>null);
    }
}

export class AddUomResponse implements IAddUomResponse {
    insertedUnitsOfMeasure!: string[] | undefined;

    constructor(data?: IAddUomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["insertedUnitsOfMeasure"])) {
                this.insertedUnitsOfMeasure = [] as any;
                for (let item of _data["insertedUnitsOfMeasure"])
                    this.insertedUnitsOfMeasure!.push(item);
            }
        }
    }

    static fromJS(data: any): AddUomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.insertedUnitsOfMeasure)) {
            data["insertedUnitsOfMeasure"] = [];
            for (let item of this.insertedUnitsOfMeasure)
                data["insertedUnitsOfMeasure"].push(item);
        }
        return data;
    }
}

export interface IAddUomResponse {
    insertedUnitsOfMeasure: string[] | undefined;
}

export class AddUomResponseOkResponse implements IAddUomResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddUomResponse;

    constructor(data?: IAddUomResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddUomResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddUomResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUomResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddUomResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddUomResponse;
}

export class BadRequestResponse implements IBadRequestResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    readonly errors!: string[] | undefined;

    constructor(data?: IBadRequestResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
        }
    }

    static fromJS(data: any): BadRequestResponse {
        data = typeof data === 'object' ? data : {};
        let result = new BadRequestResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IBadRequestResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    errors: string[] | undefined;
}

export class HttpStatusResponse implements IHttpStatusResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    readonly errors!: string[] | undefined;

    constructor(data?: IHttpStatusResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            if (Array.isArray(_data["errors"])) {
                (<any>this).errors = [] as any;
                for (let item of _data["errors"])
                    (<any>this).errors!.push(item);
            }
        }
    }

    static fromJS(data: any): HttpStatusResponse {
        data = typeof data === 'object' ? data : {};
        let result = new HttpStatusResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IHttpStatusResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    errors: string[] | undefined;
}

export class InternalServerErrorResponse implements IInternalServerErrorResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    readonly details!: string | undefined;

    constructor(data?: IInternalServerErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            (<any>this).details = _data["details"];
        }
    }

    static fromJS(data: any): InternalServerErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InternalServerErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["details"] = this.details;
        return data;
    }
}

export interface IInternalServerErrorResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    details: string | undefined;
}

export class TooManyRequestsResponse implements ITooManyRequestsResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;

    constructor(data?: ITooManyRequestsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): TooManyRequestsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new TooManyRequestsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        return data;
    }
}

export interface ITooManyRequestsResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
}

export class DeleteUomResponse implements IDeleteUomResponse {
    deletedIds!: number[] | undefined;

    constructor(data?: IDeleteUomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["deletedIds"])) {
                this.deletedIds = [] as any;
                for (let item of _data["deletedIds"])
                    this.deletedIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteUomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.deletedIds)) {
            data["deletedIds"] = [];
            for (let item of this.deletedIds)
                data["deletedIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteUomResponse {
    deletedIds: number[] | undefined;
}

export class DeleteUomResponseOkResponse implements IDeleteUomResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: DeleteUomResponse;

    constructor(data?: IDeleteUomResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? DeleteUomResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteUomResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteUomResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteUomResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: DeleteUomResponse;
}

export class UnitOfMeasureUpdateDto implements IUnitOfMeasureUpdateDto {
    name!: string | undefined;
    id!: number;

    constructor(data?: IUnitOfMeasureUpdateDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): UnitOfMeasureUpdateDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOfMeasureUpdateDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["id"] = this.id;
        return data;
    }
}

export interface IUnitOfMeasureUpdateDto {
    name: string | undefined;
    id: number;
}

export class EditUomResponse implements IEditUomResponse {
    items!: UnitOfMeasureUpdateDto[] | undefined;

    constructor(data?: IEditUomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UnitOfMeasureUpdateDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditUomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditUomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditUomResponse {
    items: UnitOfMeasureUpdateDto[] | undefined;
}

export class EditUomResponseOkResponse implements IEditUomResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditUomResponse;

    constructor(data?: IEditUomResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditUomResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditUomResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditUomResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditUomResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditUomResponse;
}

export class UnitOfMeasureListDto implements IUnitOfMeasureListDto {
    id!: number;
    name!: string | undefined;
    canBeDeleted!: boolean;

    constructor(data?: IUnitOfMeasureListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.canBeDeleted = _data["canBeDeleted"];
        }
    }

    static fromJS(data: any): UnitOfMeasureListDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitOfMeasureListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["canBeDeleted"] = this.canBeDeleted;
        return data;
    }
}

export interface IUnitOfMeasureListDto {
    id: number;
    name: string | undefined;
    canBeDeleted: boolean;
}

export class ListUomResponse implements IListUomResponse {
    total!: number;
    items!: UnitOfMeasureListDto[] | undefined;

    constructor(data?: IListUomResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(UnitOfMeasureListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListUomResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListUomResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListUomResponse {
    total: number;
    items: UnitOfMeasureListDto[] | undefined;
}

export class ListUomResponseOkResponse implements IListUomResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ListUomResponse;

    constructor(data?: IListUomResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ListUomResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListUomResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListUomResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListUomResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ListUomResponse;
}

export class NotFoundResponse implements INotFoundResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;

    constructor(data?: INotFoundResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
        }
    }

    static fromJS(data: any): NotFoundResponse {
        data = typeof data === 'object' ? data : {};
        let result = new NotFoundResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        return data;
    }
}

export interface INotFoundResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
}

export class AddScenarioRequest implements IAddScenarioRequest {
    previousScenarioId!: number | undefined;
    persistAllData!: boolean | undefined;
    description!: string | undefined;
    mtpYear!: number | undefined;
    referenceYear!: number | undefined;
    startYear!: number | undefined;
    endYear!: number | undefined;
    name!: string | undefined;
    saveAsDraft!: boolean;
    reportingOccasion!: string | undefined;

    constructor(data?: IAddScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousScenarioId = _data["previousScenarioId"];
            this.persistAllData = _data["persistAllData"];
            this.description = _data["description"];
            this.mtpYear = _data["mtpYear"];
            this.referenceYear = _data["referenceYear"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.name = _data["name"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.reportingOccasion = _data["reportingOccasion"];
        }
    }

    static fromJS(data: any): AddScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousScenarioId"] = this.previousScenarioId;
        data["persistAllData"] = this.persistAllData;
        data["description"] = this.description;
        data["mtpYear"] = this.mtpYear;
        data["referenceYear"] = this.referenceYear;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["name"] = this.name;
        data["saveAsDraft"] = this.saveAsDraft;
        data["reportingOccasion"] = this.reportingOccasion;
        return data;
    }
}

export interface IAddScenarioRequest {
    previousScenarioId: number | undefined;
    persistAllData: boolean | undefined;
    description: string | undefined;
    mtpYear: number | undefined;
    referenceYear: number | undefined;
    startYear: number | undefined;
    endYear: number | undefined;
    name: string | undefined;
    saveAsDraft: boolean;
    reportingOccasion: string | undefined;
}

export class AddScenarioResponse implements IAddScenarioResponse {
    id!: number;
    previousScenarioId!: number | undefined;
    persistAllData!: boolean | undefined;
    description!: string | undefined;
    mtpYear!: number | undefined;
    referenceYear!: number | undefined;
    startYear!: number | undefined;
    endYear!: number | undefined;
    name!: string | undefined;
    step!: number;
    saveAsDraft!: boolean | undefined;
    status!: number | undefined;
    updatedAt!: Date | undefined;
    budgetFlaggedPercent!: number | undefined;
    startedAt!: Date | undefined;
    lastTaskName!: string | undefined;
    createdByKid!: string | undefined;
    createdByName!: string | undefined;
    createdAt!: Date | undefined;
    isMarked!: boolean | undefined;
    reportingOccasion!: string | undefined;
    previousScenarioName!: string | undefined;
    previousScenarioFormulaName!: string | undefined;

    constructor(data?: IAddScenarioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.previousScenarioId = _data["previousScenarioId"];
            this.persistAllData = _data["persistAllData"];
            this.description = _data["description"];
            this.mtpYear = _data["mtpYear"];
            this.referenceYear = _data["referenceYear"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.name = _data["name"];
            this.step = _data["step"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.budgetFlaggedPercent = _data["budgetFlaggedPercent"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.lastTaskName = _data["lastTaskName"];
            this.createdByKid = _data["createdByKid"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isMarked = _data["isMarked"];
            this.reportingOccasion = _data["reportingOccasion"];
            this.previousScenarioName = _data["previousScenarioName"];
            this.previousScenarioFormulaName = _data["previousScenarioFormulaName"];
        }
    }

    static fromJS(data: any): AddScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddScenarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["previousScenarioId"] = this.previousScenarioId;
        data["persistAllData"] = this.persistAllData;
        data["description"] = this.description;
        data["mtpYear"] = this.mtpYear;
        data["referenceYear"] = this.referenceYear;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["name"] = this.name;
        data["step"] = this.step;
        data["saveAsDraft"] = this.saveAsDraft;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["budgetFlaggedPercent"] = this.budgetFlaggedPercent;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["lastTaskName"] = this.lastTaskName;
        data["createdByKid"] = this.createdByKid;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isMarked"] = this.isMarked;
        data["reportingOccasion"] = this.reportingOccasion;
        data["previousScenarioName"] = this.previousScenarioName;
        data["previousScenarioFormulaName"] = this.previousScenarioFormulaName;
        return data;
    }
}

export interface IAddScenarioResponse {
    id: number;
    previousScenarioId: number | undefined;
    persistAllData: boolean | undefined;
    description: string | undefined;
    mtpYear: number | undefined;
    referenceYear: number | undefined;
    startYear: number | undefined;
    endYear: number | undefined;
    name: string | undefined;
    step: number;
    saveAsDraft: boolean | undefined;
    status: number | undefined;
    updatedAt: Date | undefined;
    budgetFlaggedPercent: number | undefined;
    startedAt: Date | undefined;
    lastTaskName: string | undefined;
    createdByKid: string | undefined;
    createdByName: string | undefined;
    createdAt: Date | undefined;
    isMarked: boolean | undefined;
    reportingOccasion: string | undefined;
    previousScenarioName: string | undefined;
    previousScenarioFormulaName: string | undefined;
}

export class AddScenarioResponseOkResponse implements IAddScenarioResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddScenarioResponse;

    constructor(data?: IAddScenarioResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddScenarioResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddScenarioResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddScenarioResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddScenarioResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddScenarioResponse;
}

export class EditScenarioRequest implements IEditScenarioRequest {
    previousScenarioId!: number | undefined;
    persistAllData!: boolean | undefined;
    description!: string | undefined;
    mtpYear!: number | undefined;
    referenceYear!: number | undefined;
    startYear!: number | undefined;
    endYear!: number | undefined;
    name!: string | undefined;
    saveAsDraft!: boolean;
    reportingOccasion!: string | undefined;
    id!: number;

    constructor(data?: IEditScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.previousScenarioId = _data["previousScenarioId"];
            this.persistAllData = _data["persistAllData"];
            this.description = _data["description"];
            this.mtpYear = _data["mtpYear"];
            this.referenceYear = _data["referenceYear"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.name = _data["name"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.reportingOccasion = _data["reportingOccasion"];
            this.id = _data["id"];
        }
    }

    static fromJS(data: any): EditScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["previousScenarioId"] = this.previousScenarioId;
        data["persistAllData"] = this.persistAllData;
        data["description"] = this.description;
        data["mtpYear"] = this.mtpYear;
        data["referenceYear"] = this.referenceYear;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["name"] = this.name;
        data["saveAsDraft"] = this.saveAsDraft;
        data["reportingOccasion"] = this.reportingOccasion;
        data["id"] = this.id;
        return data;
    }
}

export interface IEditScenarioRequest {
    previousScenarioId: number | undefined;
    persistAllData: boolean | undefined;
    description: string | undefined;
    mtpYear: number | undefined;
    referenceYear: number | undefined;
    startYear: number | undefined;
    endYear: number | undefined;
    name: string | undefined;
    saveAsDraft: boolean;
    reportingOccasion: string | undefined;
    id: number;
}

export class EditScenarioResponse implements IEditScenarioResponse {
    id!: number;
    previousScenarioId!: number | undefined;
    persistAllData!: boolean | undefined;
    description!: string | undefined;
    mtpYear!: number | undefined;
    referenceYear!: number | undefined;
    startYear!: number | undefined;
    endYear!: number | undefined;
    name!: string | undefined;
    step!: number;
    saveAsDraft!: boolean | undefined;
    status!: number | undefined;
    updatedAt!: Date | undefined;
    budgetFlaggedPercent!: number | undefined;
    startedAt!: Date | undefined;
    lastTaskName!: string | undefined;
    createdByKid!: string | undefined;
    createdByName!: string | undefined;
    createdAt!: Date | undefined;
    isMarked!: boolean | undefined;
    reportingOccasion!: string | undefined;
    previousScenarioName!: string | undefined;
    previousScenarioFormulaName!: string | undefined;

    constructor(data?: IEditScenarioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.previousScenarioId = _data["previousScenarioId"];
            this.persistAllData = _data["persistAllData"];
            this.description = _data["description"];
            this.mtpYear = _data["mtpYear"];
            this.referenceYear = _data["referenceYear"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.name = _data["name"];
            this.step = _data["step"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.budgetFlaggedPercent = _data["budgetFlaggedPercent"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.lastTaskName = _data["lastTaskName"];
            this.createdByKid = _data["createdByKid"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isMarked = _data["isMarked"];
            this.reportingOccasion = _data["reportingOccasion"];
            this.previousScenarioName = _data["previousScenarioName"];
            this.previousScenarioFormulaName = _data["previousScenarioFormulaName"];
        }
    }

    static fromJS(data: any): EditScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditScenarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["previousScenarioId"] = this.previousScenarioId;
        data["persistAllData"] = this.persistAllData;
        data["description"] = this.description;
        data["mtpYear"] = this.mtpYear;
        data["referenceYear"] = this.referenceYear;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["name"] = this.name;
        data["step"] = this.step;
        data["saveAsDraft"] = this.saveAsDraft;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["budgetFlaggedPercent"] = this.budgetFlaggedPercent;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["lastTaskName"] = this.lastTaskName;
        data["createdByKid"] = this.createdByKid;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isMarked"] = this.isMarked;
        data["reportingOccasion"] = this.reportingOccasion;
        data["previousScenarioName"] = this.previousScenarioName;
        data["previousScenarioFormulaName"] = this.previousScenarioFormulaName;
        return data;
    }
}

export interface IEditScenarioResponse {
    id: number;
    previousScenarioId: number | undefined;
    persistAllData: boolean | undefined;
    description: string | undefined;
    mtpYear: number | undefined;
    referenceYear: number | undefined;
    startYear: number | undefined;
    endYear: number | undefined;
    name: string | undefined;
    step: number;
    saveAsDraft: boolean | undefined;
    status: number | undefined;
    updatedAt: Date | undefined;
    budgetFlaggedPercent: number | undefined;
    startedAt: Date | undefined;
    lastTaskName: string | undefined;
    createdByKid: string | undefined;
    createdByName: string | undefined;
    createdAt: Date | undefined;
    isMarked: boolean | undefined;
    reportingOccasion: string | undefined;
    previousScenarioName: string | undefined;
    previousScenarioFormulaName: string | undefined;
}

export class EditScenarioResponseOkResponse implements IEditScenarioResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditScenarioResponse;

    constructor(data?: IEditScenarioResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditScenarioResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditScenarioResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditScenarioResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditScenarioResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditScenarioResponse;
}

export class MaintenanceYearDto implements IMaintenanceYearDto {
    isSelected!: boolean;
    year!: number;

    constructor(data?: IMaintenanceYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.isSelected = _data["isSelected"];
            this.year = _data["year"];
        }
    }

    static fromJS(data: any): MaintenanceYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["isSelected"] = this.isSelected;
        data["year"] = this.year;
        return data;
    }
}

export interface IMaintenanceYearDto {
    isSelected: boolean;
    year: number;
}

export class MachineSidYearDto implements IMachineSidYearDto {
    machineSid!: number;
    years!: MaintenanceYearDto[] | undefined;

    constructor(data?: IMachineSidYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineSid = _data["machineSid"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(MaintenanceYearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MachineSidYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new MachineSidYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineSid"] = this.machineSid;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMachineSidYearDto {
    machineSid: number;
    years: MaintenanceYearDto[] | undefined;
}

export class AddMaintenanceCycleValuesRequest implements IAddMaintenanceCycleValuesRequest {
    scenarioId!: number;
    isSaveAsDraft!: boolean;
    machineSidYears!: MachineSidYearDto[] | undefined;

    constructor(data?: IAddMaintenanceCycleValuesRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.isSaveAsDraft = _data["isSaveAsDraft"];
            if (Array.isArray(_data["machineSidYears"])) {
                this.machineSidYears = [] as any;
                for (let item of _data["machineSidYears"])
                    this.machineSidYears!.push(MachineSidYearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddMaintenanceCycleValuesRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddMaintenanceCycleValuesRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["isSaveAsDraft"] = this.isSaveAsDraft;
        if (Array.isArray(this.machineSidYears)) {
            data["machineSidYears"] = [];
            for (let item of this.machineSidYears)
                data["machineSidYears"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddMaintenanceCycleValuesRequest {
    scenarioId: number;
    isSaveAsDraft: boolean;
    machineSidYears: MachineSidYearDto[] | undefined;
}

export class MaintenanceCycleValueDto implements IMaintenanceCycleValueDto {
    year!: number;
    unitId!: number;

    constructor(data?: IMaintenanceCycleValueDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.unitId = _data["unitId"];
        }
    }

    static fromJS(data: any): MaintenanceCycleValueDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceCycleValueDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["unitId"] = this.unitId;
        return data;
    }
}

export interface IMaintenanceCycleValueDto {
    year: number;
    unitId: number;
}

export class AddMaintenanceCycleValuesResponse implements IAddMaintenanceCycleValuesResponse {
    maintenanceCycleValues!: MaintenanceCycleValueDto[] | undefined;
    numberOfDeletedItems!: number;

    constructor(data?: IAddMaintenanceCycleValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["maintenanceCycleValues"])) {
                this.maintenanceCycleValues = [] as any;
                for (let item of _data["maintenanceCycleValues"])
                    this.maintenanceCycleValues!.push(MaintenanceCycleValueDto.fromJS(item));
            }
            this.numberOfDeletedItems = _data["numberOfDeletedItems"];
        }
    }

    static fromJS(data: any): AddMaintenanceCycleValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMaintenanceCycleValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.maintenanceCycleValues)) {
            data["maintenanceCycleValues"] = [];
            for (let item of this.maintenanceCycleValues)
                data["maintenanceCycleValues"].push(item.toJSON());
        }
        data["numberOfDeletedItems"] = this.numberOfDeletedItems;
        return data;
    }
}

export interface IAddMaintenanceCycleValuesResponse {
    maintenanceCycleValues: MaintenanceCycleValueDto[] | undefined;
    numberOfDeletedItems: number;
}

export class AddMaintenanceCycleValuesResponseOkResponse implements IAddMaintenanceCycleValuesResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddMaintenanceCycleValuesResponse;

    constructor(data?: IAddMaintenanceCycleValuesResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddMaintenanceCycleValuesResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddMaintenanceCycleValuesResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddMaintenanceCycleValuesResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddMaintenanceCycleValuesResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddMaintenanceCycleValuesResponse;
}

export class FormulaKpiDto implements IFormulaKpiDto {
    id!: number | undefined;
    kpiId!: string | undefined;
    benchKpiFormulaId!: number;
    isPrimaryKpi!: boolean;

    constructor(data?: IFormulaKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kpiId = _data["kpiId"];
            this.benchKpiFormulaId = _data["benchKpiFormulaId"];
            this.isPrimaryKpi = _data["isPrimaryKpi"];
        }
    }

    static fromJS(data: any): FormulaKpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new FormulaKpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kpiId"] = this.kpiId;
        data["benchKpiFormulaId"] = this.benchKpiFormulaId;
        data["isPrimaryKpi"] = this.isPrimaryKpi;
        return data;
    }
}

export interface IFormulaKpiDto {
    id: number | undefined;
    kpiId: string | undefined;
    benchKpiFormulaId: number;
    isPrimaryKpi: boolean;
}

export class AddKpiRequest implements IAddKpiRequest {
    scenarioId!: number;
    kpiTypeId!: number | undefined;
    kpiId!: string | undefined;
    unitOfMeasureId!: number | undefined;
    kpiDescription!: string | undefined;
    kpisList!: FormulaKpiDto[] | undefined;
    kpiFormula!: string | undefined;
    kpiActive!: boolean;
    unit!: boolean;
    unit0!: boolean;

    constructor(data?: IAddKpiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.kpiTypeId = _data["kpiTypeId"];
            this.kpiId = _data["kpiId"];
            this.unitOfMeasureId = _data["unitOfMeasureId"];
            this.kpiDescription = _data["kpiDescription"];
            if (Array.isArray(_data["kpisList"])) {
                this.kpisList = [] as any;
                for (let item of _data["kpisList"])
                    this.kpisList!.push(FormulaKpiDto.fromJS(item));
            }
            this.kpiFormula = _data["kpiFormula"];
            this.kpiActive = _data["kpiActive"];
            this.unit = _data["unit"];
            this.unit0 = _data["unit0"];
        }
    }

    static fromJS(data: any): AddKpiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["kpiTypeId"] = this.kpiTypeId;
        data["kpiId"] = this.kpiId;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["kpiDescription"] = this.kpiDescription;
        if (Array.isArray(this.kpisList)) {
            data["kpisList"] = [];
            for (let item of this.kpisList)
                data["kpisList"].push(item.toJSON());
        }
        data["kpiFormula"] = this.kpiFormula;
        data["kpiActive"] = this.kpiActive;
        data["unit"] = this.unit;
        data["unit0"] = this.unit0;
        return data;
    }
}

export interface IAddKpiRequest {
    scenarioId: number;
    kpiTypeId: number | undefined;
    kpiId: string | undefined;
    unitOfMeasureId: number | undefined;
    kpiDescription: string | undefined;
    kpisList: FormulaKpiDto[] | undefined;
    kpiFormula: string | undefined;
    kpiActive: boolean;
    unit: boolean;
    unit0: boolean;
}

export class KpiDto implements IKpiDto {
    kpiNumber!: number;
    kpiTypeId!: number | undefined;
    kpiId!: string | undefined;
    kpiDesc!: string | undefined;
    unitOfMeasureId!: number | undefined;
    kpiPrimary!: boolean;
    unit!: boolean;
    unitZero!: boolean;
    kpiFormula!: string | undefined;
    unitLevel!: number;
    kpiActive!: boolean;
    kpiLevel!: number;
    kpiType!: string | undefined;
    kpiUom!: string | undefined;

    constructor(data?: IKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiNumber = _data["kpiNumber"];
            this.kpiTypeId = _data["kpiTypeId"];
            this.kpiId = _data["kpiId"];
            this.kpiDesc = _data["kpiDesc"];
            this.unitOfMeasureId = _data["unitOfMeasureId"];
            this.kpiPrimary = _data["kpiPrimary"];
            this.unit = _data["unit"];
            this.unitZero = _data["unitZero"];
            this.kpiFormula = _data["kpiFormula"];
            this.unitLevel = _data["unitLevel"];
            this.kpiActive = _data["kpiActive"];
            this.kpiLevel = _data["kpiLevel"];
            this.kpiType = _data["kpiType"];
            this.kpiUom = _data["kpiUom"];
        }
    }

    static fromJS(data: any): KpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiNumber"] = this.kpiNumber;
        data["kpiTypeId"] = this.kpiTypeId;
        data["kpiId"] = this.kpiId;
        data["kpiDesc"] = this.kpiDesc;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["kpiPrimary"] = this.kpiPrimary;
        data["unit"] = this.unit;
        data["unitZero"] = this.unitZero;
        data["kpiFormula"] = this.kpiFormula;
        data["unitLevel"] = this.unitLevel;
        data["kpiActive"] = this.kpiActive;
        data["kpiLevel"] = this.kpiLevel;
        data["kpiType"] = this.kpiType;
        data["kpiUom"] = this.kpiUom;
        return data;
    }
}

export interface IKpiDto {
    kpiNumber: number;
    kpiTypeId: number | undefined;
    kpiId: string | undefined;
    kpiDesc: string | undefined;
    unitOfMeasureId: number | undefined;
    kpiPrimary: boolean;
    unit: boolean;
    unitZero: boolean;
    kpiFormula: string | undefined;
    unitLevel: number;
    kpiActive: boolean;
    kpiLevel: number;
    kpiType: string | undefined;
    kpiUom: string | undefined;
}

export class InsertFormulaKpiDto implements IInsertFormulaKpiDto {
    kpiId!: string | undefined;
    benchKpiFormulaId!: number;
    isPrimaryKpi!: boolean;

    constructor(data?: IInsertFormulaKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiId = _data["kpiId"];
            this.benchKpiFormulaId = _data["benchKpiFormulaId"];
            this.isPrimaryKpi = _data["isPrimaryKpi"];
        }
    }

    static fromJS(data: any): InsertFormulaKpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new InsertFormulaKpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiId"] = this.kpiId;
        data["benchKpiFormulaId"] = this.benchKpiFormulaId;
        data["isPrimaryKpi"] = this.isPrimaryKpi;
        return data;
    }
}

export interface IInsertFormulaKpiDto {
    kpiId: string | undefined;
    benchKpiFormulaId: number;
    isPrimaryKpi: boolean;
}

export class AddKpiResponse implements IAddKpiResponse {
    kpiFormula!: KpiDto;
    kpis!: InsertFormulaKpiDto[] | undefined;

    constructor(data?: IAddKpiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiFormula = _data["kpiFormula"] ? KpiDto.fromJS(_data["kpiFormula"]) : <any>undefined;
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(InsertFormulaKpiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddKpiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiFormula"] = this.kpiFormula ? this.kpiFormula.toJSON() : <any>undefined;
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddKpiResponse {
    kpiFormula: KpiDto;
    kpis: InsertFormulaKpiDto[] | undefined;
}

export class AddKpiResponseOkResponse implements IAddKpiResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddKpiResponse;

    constructor(data?: IAddKpiResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddKpiResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddKpiResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpiResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddKpiResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddKpiResponse;
}

export class EditFormulaRequestDto implements IEditFormulaRequestDto {
    kpiTypeId!: number | undefined;
    kpiId!: string | undefined;
    kpiDesc!: string | undefined;
    unitOfMeasureId!: number | undefined;
    unit!: boolean;
    unitZero!: boolean;
    kpiFormula!: string | undefined;
    kpiActive!: boolean;

    constructor(data?: IEditFormulaRequestDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiTypeId = _data["kpiTypeId"];
            this.kpiId = _data["kpiId"];
            this.kpiDesc = _data["kpiDesc"];
            this.unitOfMeasureId = _data["unitOfMeasureId"];
            this.unit = _data["unit"];
            this.unitZero = _data["unitZero"];
            this.kpiFormula = _data["kpiFormula"];
            this.kpiActive = _data["kpiActive"];
        }
    }

    static fromJS(data: any): EditFormulaRequestDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditFormulaRequestDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiTypeId"] = this.kpiTypeId;
        data["kpiId"] = this.kpiId;
        data["kpiDesc"] = this.kpiDesc;
        data["unitOfMeasureId"] = this.unitOfMeasureId;
        data["unit"] = this.unit;
        data["unitZero"] = this.unitZero;
        data["kpiFormula"] = this.kpiFormula;
        data["kpiActive"] = this.kpiActive;
        return data;
    }
}

export interface IEditFormulaRequestDto {
    kpiTypeId: number | undefined;
    kpiId: string | undefined;
    kpiDesc: string | undefined;
    unitOfMeasureId: number | undefined;
    unit: boolean;
    unitZero: boolean;
    kpiFormula: string | undefined;
    kpiActive: boolean;
}

export class EditKpiRequest implements IEditKpiRequest {
    kpiNumber!: number;
    scenarioId!: number;
    kpiFormula!: EditFormulaRequestDto;
    kpis!: InsertFormulaKpiDto[] | undefined;

    constructor(data?: IEditKpiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiNumber = _data["kpiNumber"];
            this.scenarioId = _data["scenarioId"];
            this.kpiFormula = _data["kpiFormula"] ? EditFormulaRequestDto.fromJS(_data["kpiFormula"]) : <any>undefined;
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(InsertFormulaKpiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditKpiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiNumber"] = this.kpiNumber;
        data["scenarioId"] = this.scenarioId;
        data["kpiFormula"] = this.kpiFormula ? this.kpiFormula.toJSON() : <any>undefined;
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditKpiRequest {
    kpiNumber: number;
    scenarioId: number;
    kpiFormula: EditFormulaRequestDto;
    kpis: InsertFormulaKpiDto[] | undefined;
}

export class EditKpiResponse implements IEditKpiResponse {
    kpiFormula!: KpiDto;
    kpis!: InsertFormulaKpiDto[] | undefined;

    constructor(data?: IEditKpiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiFormula = _data["kpiFormula"] ? KpiDto.fromJS(_data["kpiFormula"]) : <any>undefined;
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(InsertFormulaKpiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditKpiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiFormula"] = this.kpiFormula ? this.kpiFormula.toJSON() : <any>undefined;
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditKpiResponse {
    kpiFormula: KpiDto;
    kpis: InsertFormulaKpiDto[] | undefined;
}

export class EditKpiResponseOkResponse implements IEditKpiResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditKpiResponse;

    constructor(data?: IEditKpiResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditKpiResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditKpiResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditKpiResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditKpiResponse;
}

export class ActivateDeactivateKpiDto implements IActivateDeactivateKpiDto {
    kpiNumber!: number;
    isActive!: boolean;
    scenarioId!: number;

    constructor(data?: IActivateDeactivateKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiNumber = _data["kpiNumber"];
            this.isActive = _data["isActive"];
            this.scenarioId = _data["scenarioId"];
        }
    }

    static fromJS(data: any): ActivateDeactivateKpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActivateDeactivateKpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiNumber"] = this.kpiNumber;
        data["isActive"] = this.isActive;
        data["scenarioId"] = this.scenarioId;
        return data;
    }
}

export interface IActivateDeactivateKpiDto {
    kpiNumber: number;
    isActive: boolean;
    scenarioId: number;
}

export class AddKpisToScenarioRequest implements IAddKpisToScenarioRequest {
    scenarioId!: number;
    isSaveAsDraft!: boolean;
    kpis!: ActivateDeactivateKpiDto[] | undefined;

    constructor(data?: IAddKpisToScenarioRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.isSaveAsDraft = _data["isSaveAsDraft"];
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(ActivateDeactivateKpiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddKpisToScenarioRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpisToScenarioRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["isSaveAsDraft"] = this.isSaveAsDraft;
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddKpisToScenarioRequest {
    scenarioId: number;
    isSaveAsDraft: boolean;
    kpis: ActivateDeactivateKpiDto[] | undefined;
}

export class ActiveKpiDto implements IActiveKpiDto {
    id!: number;
    scenarioId!: number;
    kpiNumberId!: number;
    kpiActive!: boolean;

    constructor(data?: IActiveKpiDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.scenarioId = _data["scenarioId"];
            this.kpiNumberId = _data["kpiNumberId"];
            this.kpiActive = _data["kpiActive"];
        }
    }

    static fromJS(data: any): ActiveKpiDto {
        data = typeof data === 'object' ? data : {};
        let result = new ActiveKpiDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["scenarioId"] = this.scenarioId;
        data["kpiNumberId"] = this.kpiNumberId;
        data["kpiActive"] = this.kpiActive;
        return data;
    }
}

export interface IActiveKpiDto {
    id: number;
    scenarioId: number;
    kpiNumberId: number;
    kpiActive: boolean;
}

export class AddKpisToScenarioResponse implements IAddKpisToScenarioResponse {
    kpis!: ActiveKpiDto[] | undefined;

    constructor(data?: IAddKpisToScenarioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(ActiveKpiDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddKpisToScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpisToScenarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddKpisToScenarioResponse {
    kpis: ActiveKpiDto[] | undefined;
}

export class AddKpisToScenarioResponseOkResponse implements IAddKpisToScenarioResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddKpisToScenarioResponse;

    constructor(data?: IAddKpisToScenarioResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddKpisToScenarioResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddKpisToScenarioResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpisToScenarioResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddKpisToScenarioResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddKpisToScenarioResponse;
}

export class AddBudgetsRequest implements IAddBudgetsRequest {
    scenarioId!: number;
    saveAsDraft!: boolean;
    globalIds!: string[] | undefined;

    constructor(data?: IAddBudgetsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.saveAsDraft = _data["saveAsDraft"];
            if (Array.isArray(_data["globalIds"])) {
                this.globalIds = [] as any;
                for (let item of _data["globalIds"])
                    this.globalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddBudgetsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddBudgetsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["saveAsDraft"] = this.saveAsDraft;
        if (Array.isArray(this.globalIds)) {
            data["globalIds"] = [];
            for (let item of this.globalIds)
                data["globalIds"].push(item);
        }
        return data;
    }
}

export interface IAddBudgetsRequest {
    scenarioId: number;
    saveAsDraft: boolean;
    globalIds: string[] | undefined;
}

export class AddBudgetsResponse implements IAddBudgetsResponse {
    globalIds!: string[] | undefined;

    constructor(data?: IAddBudgetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["globalIds"])) {
                this.globalIds = [] as any;
                for (let item of _data["globalIds"])
                    this.globalIds!.push(item);
            }
        }
    }

    static fromJS(data: any): AddBudgetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddBudgetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.globalIds)) {
            data["globalIds"] = [];
            for (let item of this.globalIds)
                data["globalIds"].push(item);
        }
        return data;
    }
}

export interface IAddBudgetsResponse {
    globalIds: string[] | undefined;
}

export class AddBudgetsResponseOkResponse implements IAddBudgetsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddBudgetsResponse;

    constructor(data?: IAddBudgetsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddBudgetsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddBudgetsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddBudgetsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddBudgetsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddBudgetsResponse;
}

export class InflationDto implements IInflationDto {
    id!: number;
    year!: number;
    value!: number;

    constructor(data?: IInflationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): InflationDto {
        data = typeof data === 'object' ? data : {};
        let result = new InflationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["value"] = this.value;
        return data;
    }
}

export interface IInflationDto {
    id: number;
    year: number;
    value: number;
}

export class AddInflationRequest implements IAddInflationRequest {
    scenarioId!: number;
    saveAsDraft!: boolean;
    inflations!: InflationDto[] | undefined;

    constructor(data?: IAddInflationRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.saveAsDraft = _data["saveAsDraft"];
            if (Array.isArray(_data["inflations"])) {
                this.inflations = [] as any;
                for (let item of _data["inflations"])
                    this.inflations!.push(InflationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddInflationRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddInflationRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["saveAsDraft"] = this.saveAsDraft;
        if (Array.isArray(this.inflations)) {
            data["inflations"] = [];
            for (let item of this.inflations)
                data["inflations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddInflationRequest {
    scenarioId: number;
    saveAsDraft: boolean;
    inflations: InflationDto[] | undefined;
}

export class AddInflationResponse implements IAddInflationResponse {
    inflations!: InflationDto[] | undefined;

    constructor(data?: IAddInflationResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["inflations"])) {
                this.inflations = [] as any;
                for (let item of _data["inflations"])
                    this.inflations!.push(InflationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddInflationResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddInflationResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.inflations)) {
            data["inflations"] = [];
            for (let item of this.inflations)
                data["inflations"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddInflationResponse {
    inflations: InflationDto[] | undefined;
}

export class AddInflationResponseOkResponse implements IAddInflationResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddInflationResponse;

    constructor(data?: IAddInflationResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddInflationResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddInflationResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddInflationResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddInflationResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddInflationResponse;
}

export class AddKpiTypeRequest implements IAddKpiTypeRequest {
    kpiTypes!: string[] | undefined;

    constructor(data?: IAddKpiTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kpiTypes"])) {
                this.kpiTypes = [] as any;
                for (let item of _data["kpiTypes"])
                    this.kpiTypes!.push(item);
            }
        }
    }

    static fromJS(data: any): AddKpiTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpiTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpiTypes)) {
            data["kpiTypes"] = [];
            for (let item of this.kpiTypes)
                data["kpiTypes"].push(item);
        }
        return data;
    }
}

export interface IAddKpiTypeRequest {
    kpiTypes: string[] | undefined;
}

export class AddKpiTypeResponse implements IAddKpiTypeResponse {
    noKpiTypesAdded!: number;

    constructor(data?: IAddKpiTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noKpiTypesAdded = _data["noKpiTypesAdded"];
        }
    }

    static fromJS(data: any): AddKpiTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpiTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noKpiTypesAdded"] = this.noKpiTypesAdded;
        return data;
    }
}

export interface IAddKpiTypeResponse {
    noKpiTypesAdded: number;
}

export class AddKpiTypeResponseOkResponse implements IAddKpiTypeResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddKpiTypeResponse;

    constructor(data?: IAddKpiTypeResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddKpiTypeResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddKpiTypeResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddKpiTypeResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddKpiTypeResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddKpiTypeResponse;
}

export class DeleteKpiTypeRequest implements IDeleteKpiTypeRequest {
    kpiTypeIds!: number[] | undefined;

    constructor(data?: IDeleteKpiTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kpiTypeIds"])) {
                this.kpiTypeIds = [] as any;
                for (let item of _data["kpiTypeIds"])
                    this.kpiTypeIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteKpiTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKpiTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpiTypeIds)) {
            data["kpiTypeIds"] = [];
            for (let item of this.kpiTypeIds)
                data["kpiTypeIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteKpiTypeRequest {
    kpiTypeIds: number[] | undefined;
}

export class DeleteKpiTypeResponse implements IDeleteKpiTypeResponse {
    noKpiTypesDeleted!: number;

    constructor(data?: IDeleteKpiTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noKpiTypesDeleted = _data["noKpiTypesDeleted"];
        }
    }

    static fromJS(data: any): DeleteKpiTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKpiTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noKpiTypesDeleted"] = this.noKpiTypesDeleted;
        return data;
    }
}

export interface IDeleteKpiTypeResponse {
    noKpiTypesDeleted: number;
}

export class DeleteKpiTypeResponseOkResponse implements IDeleteKpiTypeResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: DeleteKpiTypeResponse;

    constructor(data?: IDeleteKpiTypeResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? DeleteKpiTypeResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteKpiTypeResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKpiTypeResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteKpiTypeResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: DeleteKpiTypeResponse;
}

export class EditKpiTypeDto implements IEditKpiTypeDto {
    id!: number;
    name!: string | undefined;

    constructor(data?: IEditKpiTypeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): EditKpiTypeDto {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiTypeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        return data;
    }
}

export interface IEditKpiTypeDto {
    id: number;
    name: string | undefined;
}

export class EditKpiTypeRequest implements IEditKpiTypeRequest {
    kpiTypes!: EditKpiTypeDto[] | undefined;

    constructor(data?: IEditKpiTypeRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["kpiTypes"])) {
                this.kpiTypes = [] as any;
                for (let item of _data["kpiTypes"])
                    this.kpiTypes!.push(EditKpiTypeDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditKpiTypeRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiTypeRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.kpiTypes)) {
            data["kpiTypes"] = [];
            for (let item of this.kpiTypes)
                data["kpiTypes"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditKpiTypeRequest {
    kpiTypes: EditKpiTypeDto[] | undefined;
}

export class EditKpiTypeResponse implements IEditKpiTypeResponse {
    noKpiTypesUpdated!: number;

    constructor(data?: IEditKpiTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.noKpiTypesUpdated = _data["noKpiTypesUpdated"];
        }
    }

    static fromJS(data: any): EditKpiTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["noKpiTypesUpdated"] = this.noKpiTypesUpdated;
        return data;
    }
}

export interface IEditKpiTypeResponse {
    noKpiTypesUpdated: number;
}

export class EditKpiTypeResponseOkResponse implements IEditKpiTypeResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditKpiTypeResponse;

    constructor(data?: IEditKpiTypeResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditKpiTypeResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditKpiTypeResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditKpiTypeResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditKpiTypeResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditKpiTypeResponse;
}

export class KpiTypeGetDto implements IKpiTypeGetDto {
    id!: number;
    name!: string | undefined;
    canBeDeleted!: boolean;

    constructor(data?: IKpiTypeGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.canBeDeleted = _data["canBeDeleted"];
        }
    }

    static fromJS(data: any): KpiTypeGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiTypeGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["canBeDeleted"] = this.canBeDeleted;
        return data;
    }
}

export interface IKpiTypeGetDto {
    id: number;
    name: string | undefined;
    canBeDeleted: boolean;
}

export class KpiTypeGetDtoPaginatedDto implements IKpiTypeGetDtoPaginatedDto {
    total!: number;
    items!: KpiTypeGetDto[] | undefined;

    constructor(data?: IKpiTypeGetDtoPaginatedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KpiTypeGetDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KpiTypeGetDtoPaginatedDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiTypeGetDtoPaginatedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKpiTypeGetDtoPaginatedDto {
    total: number;
    items: KpiTypeGetDto[] | undefined;
}

export class ListKpiTypeResponse implements IListKpiTypeResponse {
    kpiTypes!: KpiTypeGetDtoPaginatedDto;

    constructor(data?: IListKpiTypeResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiTypes = _data["kpiTypes"] ? KpiTypeGetDtoPaginatedDto.fromJS(_data["kpiTypes"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListKpiTypeResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListKpiTypeResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiTypes"] = this.kpiTypes ? this.kpiTypes.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListKpiTypeResponse {
    kpiTypes: KpiTypeGetDtoPaginatedDto;
}

export class ListKpiTypeResponseOkResponse implements IListKpiTypeResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ListKpiTypeResponse;

    constructor(data?: IListKpiTypeResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ListKpiTypeResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListKpiTypeResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListKpiTypeResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListKpiTypeResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ListKpiTypeResponse;
}

export class UnitAddDeleteDto implements IUnitAddDeleteDto {
    machineSid!: number;
    isSelected!: boolean;

    constructor(data?: IUnitAddDeleteDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineSid = _data["machineSid"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): UnitAddDeleteDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitAddDeleteDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineSid"] = this.machineSid;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IUnitAddDeleteDto {
    machineSid: number;
    isSelected: boolean;
}

export class AddUnitsRequest implements IAddUnitsRequest {
    scenarioId!: number;
    saveAsDraft!: boolean;
    units!: UnitAddDeleteDto[] | undefined;

    constructor(data?: IAddUnitsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.saveAsDraft = _data["saveAsDraft"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(UnitAddDeleteDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUnitsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new AddUnitsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["saveAsDraft"] = this.saveAsDraft;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddUnitsRequest {
    scenarioId: number;
    saveAsDraft: boolean;
    units: UnitAddDeleteDto[] | undefined;
}

export class UnitAddDto implements IUnitAddDto {
    scenarioId!: number;
    machineSid!: number;

    constructor(data?: IUnitAddDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.machineSid = _data["machineSid"];
        }
    }

    static fromJS(data: any): UnitAddDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitAddDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["machineSid"] = this.machineSid;
        return data;
    }
}

export interface IUnitAddDto {
    scenarioId: number;
    machineSid: number;
}

export class AddUnitsResponse implements IAddUnitsResponse {
    units!: UnitAddDto[] | undefined;

    constructor(data?: IAddUnitsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(UnitAddDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): AddUnitsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUnitsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IAddUnitsResponse {
    units: UnitAddDto[] | undefined;
}

export class AddUnitsResponseOkResponse implements IAddUnitsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: AddUnitsResponse;

    constructor(data?: IAddUnitsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? AddUnitsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): AddUnitsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new AddUnitsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IAddUnitsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: AddUnitsResponse;
}

export class UnitFilterDto implements IUnitFilterDto {
    unitSid!: number;
    unitName!: string | undefined;

    constructor(data?: IUnitFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitSid = _data["unitSid"];
            this.unitName = _data["unitName"];
        }
    }

    static fromJS(data: any): UnitFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitSid"] = this.unitSid;
        data["unitName"] = this.unitName;
        return data;
    }
}

export interface IUnitFilterDto {
    unitSid: number;
    unitName: string | undefined;
}

export class PlantFilterDto implements IPlantFilterDto {
    plantSid!: number;
    plantName!: string | undefined;
    units!: UnitFilterDto[] | undefined;

    constructor(data?: IPlantFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantSid = _data["plantSid"];
            this.plantName = _data["plantName"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(UnitFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlantFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlantFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantSid"] = this.plantSid;
        data["plantName"] = this.plantName;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlantFilterDto {
    plantSid: number;
    plantName: string | undefined;
    units: UnitFilterDto[] | undefined;
}

export class CountryFilterDto implements ICountryFilterDto {
    countryId!: number;
    countryName!: string | undefined;
    plants!: PlantFilterDto[] | undefined;

    constructor(data?: ICountryFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            if (Array.isArray(_data["plants"])) {
                this.plants = [] as any;
                for (let item of _data["plants"])
                    this.plants!.push(PlantFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        if (Array.isArray(this.plants)) {
            data["plants"] = [];
            for (let item of this.plants)
                data["plants"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountryFilterDto {
    countryId: number;
    countryName: string | undefined;
    plants: PlantFilterDto[] | undefined;
}

export class GetFiltersResponse implements IGetFiltersResponse {
    countries!: CountryFilterDto[] | undefined;
    kpiTypes!: { [key: string]: string; } | undefined;

    constructor(data?: IGetFiltersResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryFilterDto.fromJS(item));
            }
            if (_data["kpiTypes"]) {
                this.kpiTypes = {} as any;
                for (let key in _data["kpiTypes"]) {
                    if (_data["kpiTypes"].hasOwnProperty(key))
                        this.kpiTypes![key] = _data["kpiTypes"][key];
                }
            }
        }
    }

    static fromJS(data: any): GetFiltersResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiltersResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (this.kpiTypes) {
            data["kpiTypes"] = {};
            for (let key in this.kpiTypes) {
                if (this.kpiTypes.hasOwnProperty(key))
                    data["kpiTypes"][key] = this.kpiTypes[key];
            }
        }
        return data;
    }
}

export interface IGetFiltersResponse {
    countries: CountryFilterDto[] | undefined;
    kpiTypes: { [key: string]: string; } | undefined;
}

export class GetFiltersResponseOkResponse implements IGetFiltersResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetFiltersResponse;

    constructor(data?: IGetFiltersResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetFiltersResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetFiltersResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetFiltersResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetFiltersResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetFiltersResponse;
}

export class TypeMapDto implements ITypeMapDto {
    readonly sourceType!: string | undefined;
    readonly destinationType!: string | undefined;

    constructor(data?: ITypeMapDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).sourceType = _data["sourceType"];
            (<any>this).destinationType = _data["destinationType"];
        }
    }

    static fromJS(data: any): TypeMapDto {
        data = typeof data === 'object' ? data : {};
        let result = new TypeMapDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sourceType"] = this.sourceType;
        data["destinationType"] = this.destinationType;
        return data;
    }
}

export interface ITypeMapDto {
    sourceType: string | undefined;
    destinationType: string | undefined;
}

export class MaintenanceAutoMapperTypeMapsResponse implements IMaintenanceAutoMapperTypeMapsResponse {
    items!: TypeMapDto[] | undefined;

    constructor(data?: IMaintenanceAutoMapperTypeMapsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(TypeMapDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceAutoMapperTypeMapsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceAutoMapperTypeMapsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceAutoMapperTypeMapsResponse {
    items: TypeMapDto[] | undefined;
}

export class MaintenanceAutoMapperTypeMapsResponseOkResponse implements IMaintenanceAutoMapperTypeMapsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: MaintenanceAutoMapperTypeMapsResponse;

    constructor(data?: IMaintenanceAutoMapperTypeMapsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? MaintenanceAutoMapperTypeMapsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MaintenanceAutoMapperTypeMapsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceAutoMapperTypeMapsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMaintenanceAutoMapperTypeMapsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: MaintenanceAutoMapperTypeMapsResponse;
}

export class ScenarioCountResponse implements IScenarioCountResponse {
    count!: number;

    constructor(data?: IScenarioCountResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
        }
    }

    static fromJS(data: any): ScenarioCountResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCountResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        return data;
    }
}

export interface IScenarioCountResponse {
    count: number;
}

export class ScenarioCountResponseOkResponse implements IScenarioCountResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ScenarioCountResponse;

    constructor(data?: IScenarioCountResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ScenarioCountResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScenarioCountResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCountResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScenarioCountResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ScenarioCountResponse;
}

export class DeleteRequest implements IDeleteRequest {
    scenarioIds!: number[] | undefined;

    constructor(data?: IDeleteRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scenarioIds"])) {
                this.scenarioIds = [] as any;
                for (let item of _data["scenarioIds"])
                    this.scenarioIds!.push(item);
            }
        }
    }

    static fromJS(data: any): DeleteRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scenarioIds)) {
            data["scenarioIds"] = [];
            for (let item of this.scenarioIds)
                data["scenarioIds"].push(item);
        }
        return data;
    }
}

export interface IDeleteRequest {
    scenarioIds: number[] | undefined;
}

export class DeleteResponse implements IDeleteResponse {
    deletedScenarios!: number;

    constructor(data?: IDeleteResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deletedScenarios = _data["deletedScenarios"];
        }
    }

    static fromJS(data: any): DeleteResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletedScenarios"] = this.deletedScenarios;
        return data;
    }
}

export interface IDeleteResponse {
    deletedScenarios: number;
}

export class DeleteResponseOkResponse implements IDeleteResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: DeleteResponse;

    constructor(data?: IDeleteResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? DeleteResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: DeleteResponse;
}

export class DeleteKpiResponse implements IDeleteKpiResponse {

    constructor(data?: IDeleteKpiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteKpiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKpiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteKpiResponse {
}

export class DeleteKpiResponseOkResponse implements IDeleteKpiResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: DeleteKpiResponse;

    constructor(data?: IDeleteKpiResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? DeleteKpiResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteKpiResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteKpiResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteKpiResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: DeleteKpiResponse;
}

export class DeleteTestDataRequest implements IDeleteTestDataRequest {

    constructor(data?: IDeleteTestDataRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): DeleteTestDataRequest {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTestDataRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IDeleteTestDataRequest {
}

export class DeleteTestDataResponse implements IDeleteTestDataResponse {
    deletedScenarios!: number;

    constructor(data?: IDeleteTestDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.deletedScenarios = _data["deletedScenarios"];
        }
    }

    static fromJS(data: any): DeleteTestDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTestDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["deletedScenarios"] = this.deletedScenarios;
        return data;
    }
}

export interface IDeleteTestDataResponse {
    deletedScenarios: number;
}

export class DeleteTestDataResponseOkResponse implements IDeleteTestDataResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: DeleteTestDataResponse;

    constructor(data?: IDeleteTestDataResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? DeleteTestDataResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): DeleteTestDataResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new DeleteTestDataResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IDeleteTestDataResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: DeleteTestDataResponse;
}

export class CostCoefficientEditDto implements ICostCoefficientEditDto {
    id!: number;
    costValue!: number;

    constructor(data?: ICostCoefficientEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.costValue = _data["costValue"];
        }
    }

    static fromJS(data: any): CostCoefficientEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCoefficientEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["costValue"] = this.costValue;
        return data;
    }
}

export interface ICostCoefficientEditDto {
    id: number;
    costValue: number;
}

export class EditCostCoefficientRequest implements IEditCostCoefficientRequest {
    scenarioId!: number;
    isSaveAsDraft!: boolean;
    costCoefficients!: CostCoefficientEditDto[] | undefined;

    constructor(data?: IEditCostCoefficientRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.isSaveAsDraft = _data["isSaveAsDraft"];
            if (Array.isArray(_data["costCoefficients"])) {
                this.costCoefficients = [] as any;
                for (let item of _data["costCoefficients"])
                    this.costCoefficients!.push(CostCoefficientEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditCostCoefficientRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditCostCoefficientRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["isSaveAsDraft"] = this.isSaveAsDraft;
        if (Array.isArray(this.costCoefficients)) {
            data["costCoefficients"] = [];
            for (let item of this.costCoefficients)
                data["costCoefficients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditCostCoefficientRequest {
    scenarioId: number;
    isSaveAsDraft: boolean;
    costCoefficients: CostCoefficientEditDto[] | undefined;
}

export class EditCostCoefficientResponse implements IEditCostCoefficientResponse {
    costCoefficients!: CostCoefficientEditDto[] | undefined;

    constructor(data?: IEditCostCoefficientResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["costCoefficients"])) {
                this.costCoefficients = [] as any;
                for (let item of _data["costCoefficients"])
                    this.costCoefficients!.push(CostCoefficientEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditCostCoefficientResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditCostCoefficientResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.costCoefficients)) {
            data["costCoefficients"] = [];
            for (let item of this.costCoefficients)
                data["costCoefficients"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditCostCoefficientResponse {
    costCoefficients: CostCoefficientEditDto[] | undefined;
}

export class EditCostCoefficientResponseOkResponse implements IEditCostCoefficientResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditCostCoefficientResponse;

    constructor(data?: IEditCostCoefficientResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditCostCoefficientResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditCostCoefficientResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditCostCoefficientResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditCostCoefficientResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditCostCoefficientResponse;
}

export class CostModificationDto implements ICostModificationDto {
    id!: number;
    fromYear!: number;
    toYear!: number | undefined;
    percentage!: number;
    amount!: number;
    costModificationType!: number;
    budgetRequestExclusionsId!: number;

    constructor(data?: ICostModificationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.fromYear = _data["fromYear"];
            this.toYear = _data["toYear"];
            this.percentage = _data["percentage"];
            this.amount = _data["amount"];
            this.costModificationType = _data["costModificationType"];
            this.budgetRequestExclusionsId = _data["budgetRequestExclusionsId"];
        }
    }

    static fromJS(data: any): CostModificationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostModificationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["fromYear"] = this.fromYear;
        data["toYear"] = this.toYear;
        data["percentage"] = this.percentage;
        data["amount"] = this.amount;
        data["costModificationType"] = this.costModificationType;
        data["budgetRequestExclusionsId"] = this.budgetRequestExclusionsId;
        return data;
    }
}

export interface ICostModificationDto {
    id: number;
    fromYear: number;
    toYear: number | undefined;
    percentage: number;
    amount: number;
    costModificationType: number;
    budgetRequestExclusionsId: number;
}

export class EditBudgetsRequest implements IEditBudgetsRequest {
    scenarioId!: number;
    budgetRequestExclusionId!: number;
    justification!: string | undefined;
    costModifications!: CostModificationDto[] | undefined;

    constructor(data?: IEditBudgetsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.budgetRequestExclusionId = _data["budgetRequestExclusionId"];
            this.justification = _data["justification"];
            if (Array.isArray(_data["costModifications"])) {
                this.costModifications = [] as any;
                for (let item of _data["costModifications"])
                    this.costModifications!.push(CostModificationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditBudgetsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditBudgetsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["budgetRequestExclusionId"] = this.budgetRequestExclusionId;
        data["justification"] = this.justification;
        if (Array.isArray(this.costModifications)) {
            data["costModifications"] = [];
            for (let item of this.costModifications)
                data["costModifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditBudgetsRequest {
    scenarioId: number;
    budgetRequestExclusionId: number;
    justification: string | undefined;
    costModifications: CostModificationDto[] | undefined;
}

export class EditBudgetsResponse implements IEditBudgetsResponse {
    costModificationsAdded!: number;

    constructor(data?: IEditBudgetsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.costModificationsAdded = _data["costModificationsAdded"];
        }
    }

    static fromJS(data: any): EditBudgetsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditBudgetsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["costModificationsAdded"] = this.costModificationsAdded;
        return data;
    }
}

export interface IEditBudgetsResponse {
    costModificationsAdded: number;
}

export class EditBudgetsResponseOkResponse implements IEditBudgetsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditBudgetsResponse;

    constructor(data?: IEditBudgetsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditBudgetsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditBudgetsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditBudgetsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditBudgetsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditBudgetsResponse;
}

export class PrimaryDataKpiEditDto implements IPrimaryDataKpiEditDto {
    primId!: number;
    value!: number;
    year!: number;
    idExists!: boolean;

    constructor(data?: IPrimaryDataKpiEditDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primId = _data["primId"];
            this.value = _data["value"];
            this.year = _data["year"];
            this.idExists = _data["idExists"];
        }
    }

    static fromJS(data: any): PrimaryDataKpiEditDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryDataKpiEditDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primId"] = this.primId;
        data["value"] = this.value;
        data["year"] = this.year;
        data["idExists"] = this.idExists;
        return data;
    }
}

export interface IPrimaryDataKpiEditDto {
    primId: number;
    value: number;
    year: number;
    idExists: boolean;
}

export class EditPrimaryKpiRequest implements IEditPrimaryKpiRequest {
    scenarioId!: number;
    saveAsDraft!: boolean;
    primaryDataKpis!: PrimaryDataKpiEditDto[] | undefined;

    constructor(data?: IEditPrimaryKpiRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.saveAsDraft = _data["saveAsDraft"];
            if (Array.isArray(_data["primaryDataKpis"])) {
                this.primaryDataKpis = [] as any;
                for (let item of _data["primaryDataKpis"])
                    this.primaryDataKpis!.push(PrimaryDataKpiEditDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EditPrimaryKpiRequest {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrimaryKpiRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["saveAsDraft"] = this.saveAsDraft;
        if (Array.isArray(this.primaryDataKpis)) {
            data["primaryDataKpis"] = [];
            for (let item of this.primaryDataKpis)
                data["primaryDataKpis"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEditPrimaryKpiRequest {
    scenarioId: number;
    saveAsDraft: boolean;
    primaryDataKpis: PrimaryDataKpiEditDto[] | undefined;
}

export class EditPrimaryKpiResponse implements IEditPrimaryKpiResponse {
    primaryKpisEdited!: number;

    constructor(data?: IEditPrimaryKpiResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKpisEdited = _data["primaryKpisEdited"];
        }
    }

    static fromJS(data: any): EditPrimaryKpiResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrimaryKpiResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKpisEdited"] = this.primaryKpisEdited;
        return data;
    }
}

export interface IEditPrimaryKpiResponse {
    primaryKpisEdited: number;
}

export class EditPrimaryKpiResponseOkResponse implements IEditPrimaryKpiResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EditPrimaryKpiResponse;

    constructor(data?: IEditPrimaryKpiResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EditPrimaryKpiResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EditPrimaryKpiResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EditPrimaryKpiResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEditPrimaryKpiResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EditPrimaryKpiResponse;
}

/** 1 = KPI_ID (FORMULA.KPI_ID) 2 = NAME (names.NAME) */
export enum SortablePrimaryDataField {
    KPI_ID = 1,
    NAME = 2,
}

/** 0 = Ascending 1 = Descending */
export enum ListSortDirection {
    Ascending = 0,
    Descending = 1,
}

export class GetScenarioResponse implements IGetScenarioResponse {
    id!: number;
    previousScenarioId!: number | undefined;
    persistAllData!: boolean | undefined;
    description!: string | undefined;
    mtpYear!: number | undefined;
    referenceYear!: number | undefined;
    startYear!: number | undefined;
    endYear!: number | undefined;
    name!: string | undefined;
    step!: number;
    saveAsDraft!: boolean | undefined;
    status!: number | undefined;
    updatedAt!: Date | undefined;
    budgetFlaggedPercent!: number | undefined;
    startedAt!: Date | undefined;
    lastTaskName!: string | undefined;
    createdByKid!: string | undefined;
    createdByName!: string | undefined;
    createdAt!: Date | undefined;
    isMarked!: boolean | undefined;
    reportingOccasion!: string | undefined;
    previousScenarioName!: string | undefined;
    previousScenarioFormulaName!: string | undefined;

    constructor(data?: IGetScenarioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.previousScenarioId = _data["previousScenarioId"];
            this.persistAllData = _data["persistAllData"];
            this.description = _data["description"];
            this.mtpYear = _data["mtpYear"];
            this.referenceYear = _data["referenceYear"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.name = _data["name"];
            this.step = _data["step"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.budgetFlaggedPercent = _data["budgetFlaggedPercent"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.lastTaskName = _data["lastTaskName"];
            this.createdByKid = _data["createdByKid"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isMarked = _data["isMarked"];
            this.reportingOccasion = _data["reportingOccasion"];
            this.previousScenarioName = _data["previousScenarioName"];
            this.previousScenarioFormulaName = _data["previousScenarioFormulaName"];
        }
    }

    static fromJS(data: any): GetScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetScenarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["previousScenarioId"] = this.previousScenarioId;
        data["persistAllData"] = this.persistAllData;
        data["description"] = this.description;
        data["mtpYear"] = this.mtpYear;
        data["referenceYear"] = this.referenceYear;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["name"] = this.name;
        data["step"] = this.step;
        data["saveAsDraft"] = this.saveAsDraft;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["budgetFlaggedPercent"] = this.budgetFlaggedPercent;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["lastTaskName"] = this.lastTaskName;
        data["createdByKid"] = this.createdByKid;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isMarked"] = this.isMarked;
        data["reportingOccasion"] = this.reportingOccasion;
        data["previousScenarioName"] = this.previousScenarioName;
        data["previousScenarioFormulaName"] = this.previousScenarioFormulaName;
        return data;
    }
}

export interface IGetScenarioResponse {
    id: number;
    previousScenarioId: number | undefined;
    persistAllData: boolean | undefined;
    description: string | undefined;
    mtpYear: number | undefined;
    referenceYear: number | undefined;
    startYear: number | undefined;
    endYear: number | undefined;
    name: string | undefined;
    step: number;
    saveAsDraft: boolean | undefined;
    status: number | undefined;
    updatedAt: Date | undefined;
    budgetFlaggedPercent: number | undefined;
    startedAt: Date | undefined;
    lastTaskName: string | undefined;
    createdByKid: string | undefined;
    createdByName: string | undefined;
    createdAt: Date | undefined;
    isMarked: boolean | undefined;
    reportingOccasion: string | undefined;
    previousScenarioName: string | undefined;
    previousScenarioFormulaName: string | undefined;
}

export class GetScenarioResponseOkResponse implements IGetScenarioResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetScenarioResponse;

    constructor(data?: IGetScenarioResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetScenarioResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetScenarioResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetScenarioResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetScenarioResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetScenarioResponse;
}

export class BudgetFlaggedDto implements IBudgetFlaggedDto {
    name!: string | undefined;
    localName!: string | undefined;
    plantName!: string | undefined;
    unitName!: string | undefined;
    forecast!: number;
    new1!: number;
    new2!: number;
    new3!: number;
    correctionType!: number;
    technologyName!: string | undefined;
    countryName!: string | undefined;

    constructor(data?: IBudgetFlaggedDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.localName = _data["localName"];
            this.plantName = _data["plantName"];
            this.unitName = _data["unitName"];
            this.forecast = _data["forecast"];
            this.new1 = _data["new1"];
            this.new2 = _data["new2"];
            this.new3 = _data["new3"];
            this.correctionType = _data["correctionType"];
            this.technologyName = _data["technologyName"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): BudgetFlaggedDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetFlaggedDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["localName"] = this.localName;
        data["plantName"] = this.plantName;
        data["unitName"] = this.unitName;
        data["forecast"] = this.forecast;
        data["new1"] = this.new1;
        data["new2"] = this.new2;
        data["new3"] = this.new3;
        data["correctionType"] = this.correctionType;
        data["technologyName"] = this.technologyName;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface IBudgetFlaggedDto {
    name: string | undefined;
    localName: string | undefined;
    plantName: string | undefined;
    unitName: string | undefined;
    forecast: number;
    new1: number;
    new2: number;
    new3: number;
    correctionType: number;
    technologyName: string | undefined;
    countryName: string | undefined;
}

export class BudgetRequestGetDto implements IBudgetRequestGetDto {
    scenarioId!: number;
    globalId!: string | undefined;
    projectName!: string | undefined;
    planningControllingClassification!: number;
    machineSid!: number;
    localName!: string | undefined;
    fundingStatus!: number | undefined;
    id!: number;
    correctionType!: number | undefined;
    plantName!: string | undefined;
    unitName!: string | undefined;
    forecast!: number;
    new1!: number;
    new2!: number;
    new3!: number;
    technologyName!: string | undefined;
    countryName!: string | undefined;
    modifications!: BudgetFlaggedDto[] | undefined;

    constructor(data?: IBudgetRequestGetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.globalId = _data["globalId"];
            this.projectName = _data["projectName"];
            this.planningControllingClassification = _data["planningControllingClassification"];
            this.machineSid = _data["machineSid"];
            this.localName = _data["localName"];
            this.fundingStatus = _data["fundingStatus"];
            this.id = _data["id"];
            this.correctionType = _data["correctionType"];
            this.plantName = _data["plantName"];
            this.unitName = _data["unitName"];
            this.forecast = _data["forecast"];
            this.new1 = _data["new1"];
            this.new2 = _data["new2"];
            this.new3 = _data["new3"];
            this.technologyName = _data["technologyName"];
            this.countryName = _data["countryName"];
            if (Array.isArray(_data["modifications"])) {
                this.modifications = [] as any;
                for (let item of _data["modifications"])
                    this.modifications!.push(BudgetFlaggedDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): BudgetRequestGetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetRequestGetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["globalId"] = this.globalId;
        data["projectName"] = this.projectName;
        data["planningControllingClassification"] = this.planningControllingClassification;
        data["machineSid"] = this.machineSid;
        data["localName"] = this.localName;
        data["fundingStatus"] = this.fundingStatus;
        data["id"] = this.id;
        data["correctionType"] = this.correctionType;
        data["plantName"] = this.plantName;
        data["unitName"] = this.unitName;
        data["forecast"] = this.forecast;
        data["new1"] = this.new1;
        data["new2"] = this.new2;
        data["new3"] = this.new3;
        data["technologyName"] = this.technologyName;
        data["countryName"] = this.countryName;
        if (Array.isArray(this.modifications)) {
            data["modifications"] = [];
            for (let item of this.modifications)
                data["modifications"].push(item.toJSON());
        }
        return data;
    }
}

export interface IBudgetRequestGetDto {
    scenarioId: number;
    globalId: string | undefined;
    projectName: string | undefined;
    planningControllingClassification: number;
    machineSid: number;
    localName: string | undefined;
    fundingStatus: number | undefined;
    id: number;
    correctionType: number | undefined;
    plantName: string | undefined;
    unitName: string | undefined;
    forecast: number;
    new1: number;
    new2: number;
    new3: number;
    technologyName: string | undefined;
    countryName: string | undefined;
    modifications: BudgetFlaggedDto[] | undefined;
}

export class GetBudgetResponse implements IGetBudgetResponse {
    budgets!: BudgetRequestGetDto[] | undefined;
    count!: number;
    percentage!: number;

    constructor(data?: IGetBudgetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgets"])) {
                this.budgets = [] as any;
                for (let item of _data["budgets"])
                    this.budgets!.push(BudgetRequestGetDto.fromJS(item));
            }
            this.count = _data["count"];
            this.percentage = _data["percentage"];
        }
    }

    static fromJS(data: any): GetBudgetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgets)) {
            data["budgets"] = [];
            for (let item of this.budgets)
                data["budgets"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["percentage"] = this.percentage;
        return data;
    }
}

export interface IGetBudgetResponse {
    budgets: BudgetRequestGetDto[] | undefined;
    count: number;
    percentage: number;
}

export class GetBudgetResponseOkResponse implements IGetBudgetResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetBudgetResponse;

    constructor(data?: IGetBudgetResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetBudgetResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBudgetResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBudgetResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetBudgetResponse;
}

export class BudgetDto implements IBudgetDto {
    globalId!: string | undefined;
    name!: string | undefined;
    plantName!: string | undefined;
    unitName!: string | undefined;
    machineSid!: number;
    outageId!: string | undefined;
    forecast!: number | undefined;
    new1!: number | undefined;
    new2!: number | undefined;
    new3!: number | undefined;
    planningAndControllingClassification!: number;
    projectType!: number;
    aeroClassification!: number;
    currency!: string | undefined;
    technologyName!: string | undefined;
    countryName!: string | undefined;
    localName!: string | undefined;
    isFlagged!: boolean;
    fundingStatus!: number | undefined;

    constructor(data?: IBudgetDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.globalId = _data["globalId"];
            this.name = _data["name"];
            this.plantName = _data["plantName"];
            this.unitName = _data["unitName"];
            this.machineSid = _data["machineSid"];
            this.outageId = _data["outageId"];
            this.forecast = _data["forecast"];
            this.new1 = _data["new1"];
            this.new2 = _data["new2"];
            this.new3 = _data["new3"];
            this.planningAndControllingClassification = _data["planningAndControllingClassification"];
            this.projectType = _data["projectType"];
            this.aeroClassification = _data["aeroClassification"];
            this.currency = _data["currency"];
            this.technologyName = _data["technologyName"];
            this.countryName = _data["countryName"];
            this.localName = _data["localName"];
            this.isFlagged = _data["isFlagged"];
            this.fundingStatus = _data["fundingStatus"];
        }
    }

    static fromJS(data: any): BudgetDto {
        data = typeof data === 'object' ? data : {};
        let result = new BudgetDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["globalId"] = this.globalId;
        data["name"] = this.name;
        data["plantName"] = this.plantName;
        data["unitName"] = this.unitName;
        data["machineSid"] = this.machineSid;
        data["outageId"] = this.outageId;
        data["forecast"] = this.forecast;
        data["new1"] = this.new1;
        data["new2"] = this.new2;
        data["new3"] = this.new3;
        data["planningAndControllingClassification"] = this.planningAndControllingClassification;
        data["projectType"] = this.projectType;
        data["aeroClassification"] = this.aeroClassification;
        data["currency"] = this.currency;
        data["technologyName"] = this.technologyName;
        data["countryName"] = this.countryName;
        data["localName"] = this.localName;
        data["isFlagged"] = this.isFlagged;
        data["fundingStatus"] = this.fundingStatus;
        return data;
    }
}

export interface IBudgetDto {
    globalId: string | undefined;
    name: string | undefined;
    plantName: string | undefined;
    unitName: string | undefined;
    machineSid: number;
    outageId: string | undefined;
    forecast: number | undefined;
    new1: number | undefined;
    new2: number | undefined;
    new3: number | undefined;
    planningAndControllingClassification: number;
    projectType: number;
    aeroClassification: number;
    currency: string | undefined;
    technologyName: string | undefined;
    countryName: string | undefined;
    localName: string | undefined;
    isFlagged: boolean;
    fundingStatus: number | undefined;
}

export class GetBudgetsInMtpYearResponse implements IGetBudgetsInMtpYearResponse {
    budgets!: BudgetDto[] | undefined;
    total!: number;

    constructor(data?: IGetBudgetsInMtpYearResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["budgets"])) {
                this.budgets = [] as any;
                for (let item of _data["budgets"])
                    this.budgets!.push(BudgetDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): GetBudgetsInMtpYearResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetsInMtpYearResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.budgets)) {
            data["budgets"] = [];
            for (let item of this.budgets)
                data["budgets"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IGetBudgetsInMtpYearResponse {
    budgets: BudgetDto[] | undefined;
    total: number;
}

export class GetBudgetsInMtpYearResponseOkResponse implements IGetBudgetsInMtpYearResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetBudgetsInMtpYearResponse;

    constructor(data?: IGetBudgetsInMtpYearResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetBudgetsInMtpYearResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetBudgetsInMtpYearResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetBudgetsInMtpYearResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetBudgetsInMtpYearResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetBudgetsInMtpYearResponse;
}

export class KpiReportYearDto implements IKpiReportYearDto {
    year!: number;
    value!: number;

    constructor(data?: IKpiReportYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.value = _data["value"];
        }
    }

    static fromJS(data: any): KpiReportYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiReportYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["value"] = this.value;
        return data;
    }
}

export interface IKpiReportYearDto {
    year: number;
    value: number;
}

export class KpiReportUnitDto implements IKpiReportUnitDto {
    machineSid!: number;
    years!: KpiReportYearDto[] | undefined;

    constructor(data?: IKpiReportUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineSid = _data["machineSid"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(KpiReportYearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KpiReportUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiReportUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineSid"] = this.machineSid;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKpiReportUnitDto {
    machineSid: number;
    years: KpiReportYearDto[] | undefined;
}

export class GetKpiReportResponse implements IGetKpiReportResponse {
    items!: KpiReportUnitDto[] | undefined;

    constructor(data?: IGetKpiReportResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KpiReportUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): GetKpiReportResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKpiReportResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IGetKpiReportResponse {
    items: KpiReportUnitDto[] | undefined;
}

export class GetKpiReportResponseOkResponse implements IGetKpiReportResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetKpiReportResponse;

    constructor(data?: IGetKpiReportResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetKpiReportResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetKpiReportResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetKpiReportResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetKpiReportResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetKpiReportResponse;
}

export class GetPmlMtpsRequest implements IGetPmlMtpsRequest {

    constructor(data?: IGetPmlMtpsRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): GetPmlMtpsRequest {
        data = typeof data === 'object' ? data : {};
        let result = new GetPmlMtpsRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IGetPmlMtpsRequest {
}

export class GetPmlMtpsResponse implements IGetPmlMtpsResponse {
    mtpList!: number[] | undefined;

    constructor(data?: IGetPmlMtpsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mtpList"])) {
                this.mtpList = [] as any;
                for (let item of _data["mtpList"])
                    this.mtpList!.push(item);
            }
        }
    }

    static fromJS(data: any): GetPmlMtpsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPmlMtpsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mtpList)) {
            data["mtpList"] = [];
            for (let item of this.mtpList)
                data["mtpList"].push(item);
        }
        return data;
    }
}

export interface IGetPmlMtpsResponse {
    mtpList: number[] | undefined;
}

export class GetPmlMtpsResponseOkResponse implements IGetPmlMtpsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetPmlMtpsResponse;

    constructor(data?: IGetPmlMtpsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetPmlMtpsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetPmlMtpsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetPmlMtpsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetPmlMtpsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetPmlMtpsResponse;
}

export class GetTrendReportsResponse implements IGetTrendReportsResponse {
    trendChartData!: { [key: string]: KpiReportUnitDto[]; } | undefined;

    constructor(data?: IGetTrendReportsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (_data["trendChartData"]) {
                this.trendChartData = {} as any;
                for (let key in _data["trendChartData"]) {
                    if (_data["trendChartData"].hasOwnProperty(key))
                        this.trendChartData![key] = _data["trendChartData"][key] ? _data["trendChartData"][key].map((i: any) => KpiReportUnitDto.fromJS(i)) : [];
                }
            }
        }
    }

    static fromJS(data: any): GetTrendReportsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrendReportsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (this.trendChartData) {
            data["trendChartData"] = {};
            for (let key in this.trendChartData) {
                if (this.trendChartData.hasOwnProperty(key))
                    data["trendChartData"][key] = this.trendChartData[key];
            }
        }
        return data;
    }
}

export interface IGetTrendReportsResponse {
    trendChartData: { [key: string]: KpiReportUnitDto[]; } | undefined;
}

export class GetTrendReportsResponseOkResponse implements IGetTrendReportsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: GetTrendReportsResponse;

    constructor(data?: IGetTrendReportsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? GetTrendReportsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): GetTrendReportsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new GetTrendReportsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IGetTrendReportsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: GetTrendReportsResponse;
}

export class ImportKpiFromScenarioResponse implements IImportKpiFromScenarioResponse {

    constructor(data?: IImportKpiFromScenarioResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): ImportKpiFromScenarioResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportKpiFromScenarioResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IImportKpiFromScenarioResponse {
}

export class ImportKpiFromScenarioResponseOkResponse implements IImportKpiFromScenarioResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ImportKpiFromScenarioResponse;

    constructor(data?: IImportKpiFromScenarioResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ImportKpiFromScenarioResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ImportKpiFromScenarioResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ImportKpiFromScenarioResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IImportKpiFromScenarioResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ImportKpiFromScenarioResponse;
}

export class KpiAnalysisItemDto implements IKpiAnalysisItemDto {
    id!: string | undefined;
    formula!: string | undefined;
    value!: number | undefined;
    isDataFromVirtual!: boolean;
    children!: KpiAnalysisItemDto[] | undefined;

    constructor(data?: IKpiAnalysisItemDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.formula = _data["formula"];
            this.value = _data["value"];
            this.isDataFromVirtual = _data["isDataFromVirtual"];
            if (Array.isArray(_data["children"])) {
                this.children = [] as any;
                for (let item of _data["children"])
                    this.children!.push(KpiAnalysisItemDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KpiAnalysisItemDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiAnalysisItemDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["formula"] = this.formula;
        data["value"] = this.value;
        data["isDataFromVirtual"] = this.isDataFromVirtual;
        if (Array.isArray(this.children)) {
            data["children"] = [];
            for (let item of this.children)
                data["children"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKpiAnalysisItemDto {
    id: string | undefined;
    formula: string | undefined;
    value: number | undefined;
    isDataFromVirtual: boolean;
    children: KpiAnalysisItemDto[] | undefined;
}

export class KpiAnalysisResponse implements IKpiAnalysisResponse {
    rootKpi!: KpiAnalysisItemDto;

    constructor(data?: IKpiAnalysisResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.rootKpi = _data["rootKpi"] ? KpiAnalysisItemDto.fromJS(_data["rootKpi"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KpiAnalysisResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KpiAnalysisResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["rootKpi"] = this.rootKpi ? this.rootKpi.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKpiAnalysisResponse {
    rootKpi: KpiAnalysisItemDto;
}

export class KpiAnalysisResponseOkResponse implements IKpiAnalysisResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: KpiAnalysisResponse;

    constructor(data?: IKpiAnalysisResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? KpiAnalysisResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KpiAnalysisResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KpiAnalysisResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKpiAnalysisResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: KpiAnalysisResponse;
}

export class UnitDto implements IUnitDto {
    machineSid!: number;
    unitName!: string | undefined;
    isSelected!: boolean;

    constructor(data?: IUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineSid = _data["machineSid"];
            this.unitName = _data["unitName"];
            this.isSelected = _data["isSelected"];
        }
    }

    static fromJS(data: any): UnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineSid"] = this.machineSid;
        data["unitName"] = this.unitName;
        data["isSelected"] = this.isSelected;
        return data;
    }
}

export interface IUnitDto {
    machineSid: number;
    unitName: string | undefined;
    isSelected: boolean;
}

export class PlantDto implements IPlantDto {
    plantName!: string | undefined;
    plantSid!: number;
    countryName!: string | undefined;
    countrySid!: number;
    technologyName!: string | undefined;
    technologySid!: number;
    isSelected!: boolean;
    units!: UnitDto[] | undefined;

    constructor(data?: IPlantDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.plantName = _data["plantName"];
            this.plantSid = _data["plantSid"];
            this.countryName = _data["countryName"];
            this.countrySid = _data["countrySid"];
            this.technologyName = _data["technologyName"];
            this.technologySid = _data["technologySid"];
            this.isSelected = _data["isSelected"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(UnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PlantDto {
        data = typeof data === 'object' ? data : {};
        let result = new PlantDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["plantName"] = this.plantName;
        data["plantSid"] = this.plantSid;
        data["countryName"] = this.countryName;
        data["countrySid"] = this.countrySid;
        data["technologyName"] = this.technologyName;
        data["technologySid"] = this.technologySid;
        data["isSelected"] = this.isSelected;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPlantDto {
    plantName: string | undefined;
    plantSid: number;
    countryName: string | undefined;
    countrySid: number;
    technologyName: string | undefined;
    technologySid: number;
    isSelected: boolean;
    units: UnitDto[] | undefined;
}

export class CountryDto implements ICountryDto {
    countrySid!: number;
    countryName!: string | undefined;

    constructor(data?: ICountryDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countrySid = _data["countrySid"];
            this.countryName = _data["countryName"];
        }
    }

    static fromJS(data: any): CountryDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countrySid"] = this.countrySid;
        data["countryName"] = this.countryName;
        return data;
    }
}

export interface ICountryDto {
    countrySid: number;
    countryName: string | undefined;
}

export class TechnologyDto implements ITechnologyDto {
    technologySid!: number;
    technologyName!: string | undefined;

    constructor(data?: ITechnologyDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.technologySid = _data["technologySid"];
            this.technologyName = _data["technologyName"];
        }
    }

    static fromJS(data: any): TechnologyDto {
        data = typeof data === 'object' ? data : {};
        let result = new TechnologyDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["technologySid"] = this.technologySid;
        data["technologyName"] = this.technologyName;
        return data;
    }
}

export interface ITechnologyDto {
    technologySid: number;
    technologyName: string | undefined;
}

export class UnitsListResponse implements IUnitsListResponse {
    plants!: PlantDto[] | undefined;
    countries!: CountryDto[] | undefined;
    technologies!: TechnologyDto[] | undefined;
    count!: number;
    sitesCount!: number;
    unitsCount!: number;
    isEditable!: boolean;

    constructor(data?: IUnitsListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["plants"])) {
                this.plants = [] as any;
                for (let item of _data["plants"])
                    this.plants!.push(PlantDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(CountryDto.fromJS(item));
            }
            if (Array.isArray(_data["technologies"])) {
                this.technologies = [] as any;
                for (let item of _data["technologies"])
                    this.technologies!.push(TechnologyDto.fromJS(item));
            }
            this.count = _data["count"];
            this.sitesCount = _data["sitesCount"];
            this.unitsCount = _data["unitsCount"];
            this.isEditable = _data["isEditable"];
        }
    }

    static fromJS(data: any): UnitsListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.plants)) {
            data["plants"] = [];
            for (let item of this.plants)
                data["plants"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.technologies)) {
            data["technologies"] = [];
            for (let item of this.technologies)
                data["technologies"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["sitesCount"] = this.sitesCount;
        data["unitsCount"] = this.unitsCount;
        data["isEditable"] = this.isEditable;
        return data;
    }
}

export interface IUnitsListResponse {
    plants: PlantDto[] | undefined;
    countries: CountryDto[] | undefined;
    technologies: TechnologyDto[] | undefined;
    count: number;
    sitesCount: number;
    unitsCount: number;
    isEditable: boolean;
}

export class UnitsListResponseOkResponse implements IUnitsListResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: UnitsListResponse;

    constructor(data?: IUnitsListResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? UnitsListResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UnitsListResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UnitsListResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUnitsListResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: UnitsListResponse;
}

/** 1 = MTP_YEAR 2 = REFERENCE_YEAR 3 = NAME 4 = STATUS 5 = CREATED_BY_KID 6 = CREATED_BY_NAME 7 = CREATED_AT 8 = UPDATED_AT */
export enum SortableScenarioField {
    MTP_YEAR = 1,
    REFERENCE_YEAR = 2,
    NAME = 3,
    STATUS = 4,
    CREATED_BY_KID = 5,
    CREATED_BY_NAME = 6,
    CREATED_AT = 7,
    UPDATED_AT = 8,
}

export class ScenarioList implements IScenarioList {
    id!: number;
    previousScenarioId!: number | undefined;
    persistAllData!: boolean | undefined;
    description!: string | undefined;
    mtpYear!: number | undefined;
    referenceYear!: number | undefined;
    startYear!: number | undefined;
    endYear!: number | undefined;
    name!: string | undefined;
    step!: number;
    saveAsDraft!: boolean | undefined;
    status!: number | undefined;
    updatedAt!: Date | undefined;
    budgetFlaggedPercent!: number | undefined;
    startedAt!: Date | undefined;
    lastTaskName!: string | undefined;
    createdByKid!: string | undefined;
    createdByName!: string | undefined;
    createdAt!: Date | undefined;
    isMarked!: boolean | undefined;
    reportingOccasion!: string | undefined;
    hasRan!: boolean;
    canBeDeleted!: boolean;
    flagged!: number;
    reviewed!: number;

    constructor(data?: IScenarioList) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.previousScenarioId = _data["previousScenarioId"];
            this.persistAllData = _data["persistAllData"];
            this.description = _data["description"];
            this.mtpYear = _data["mtpYear"];
            this.referenceYear = _data["referenceYear"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.name = _data["name"];
            this.step = _data["step"];
            this.saveAsDraft = _data["saveAsDraft"];
            this.status = _data["status"];
            this.updatedAt = _data["updatedAt"] ? new Date(_data["updatedAt"].toString()) : <any>undefined;
            this.budgetFlaggedPercent = _data["budgetFlaggedPercent"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.lastTaskName = _data["lastTaskName"];
            this.createdByKid = _data["createdByKid"];
            this.createdByName = _data["createdByName"];
            this.createdAt = _data["createdAt"] ? new Date(_data["createdAt"].toString()) : <any>undefined;
            this.isMarked = _data["isMarked"];
            this.reportingOccasion = _data["reportingOccasion"];
            this.hasRan = _data["hasRan"];
            this.canBeDeleted = _data["canBeDeleted"];
            this.flagged = _data["flagged"];
            this.reviewed = _data["reviewed"];
        }
    }

    static fromJS(data: any): ScenarioList {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioList();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["previousScenarioId"] = this.previousScenarioId;
        data["persistAllData"] = this.persistAllData;
        data["description"] = this.description;
        data["mtpYear"] = this.mtpYear;
        data["referenceYear"] = this.referenceYear;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["name"] = this.name;
        data["step"] = this.step;
        data["saveAsDraft"] = this.saveAsDraft;
        data["status"] = this.status;
        data["updatedAt"] = this.updatedAt ? this.updatedAt.toISOString() : <any>undefined;
        data["budgetFlaggedPercent"] = this.budgetFlaggedPercent;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["lastTaskName"] = this.lastTaskName;
        data["createdByKid"] = this.createdByKid;
        data["createdByName"] = this.createdByName;
        data["createdAt"] = this.createdAt ? this.createdAt.toISOString() : <any>undefined;
        data["isMarked"] = this.isMarked;
        data["reportingOccasion"] = this.reportingOccasion;
        data["hasRan"] = this.hasRan;
        data["canBeDeleted"] = this.canBeDeleted;
        data["flagged"] = this.flagged;
        data["reviewed"] = this.reviewed;
        return data;
    }
}

export interface IScenarioList {
    id: number;
    previousScenarioId: number | undefined;
    persistAllData: boolean | undefined;
    description: string | undefined;
    mtpYear: number | undefined;
    referenceYear: number | undefined;
    startYear: number | undefined;
    endYear: number | undefined;
    name: string | undefined;
    step: number;
    saveAsDraft: boolean | undefined;
    status: number | undefined;
    updatedAt: Date | undefined;
    budgetFlaggedPercent: number | undefined;
    startedAt: Date | undefined;
    lastTaskName: string | undefined;
    createdByKid: string | undefined;
    createdByName: string | undefined;
    createdAt: Date | undefined;
    isMarked: boolean | undefined;
    reportingOccasion: string | undefined;
    hasRan: boolean;
    canBeDeleted: boolean;
    flagged: number;
    reviewed: number;
}

export class ScenarioListResponse implements IScenarioListResponse {
    count!: number;
    items!: ScenarioList[] | undefined;

    constructor(data?: IScenarioListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScenarioList.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioListResponse {
    count: number;
    items: ScenarioList[] | undefined;
}

export class ScenarioListResponseOkResponse implements IScenarioListResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ScenarioListResponse;

    constructor(data?: IScenarioListResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ScenarioListResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScenarioListResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioListResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScenarioListResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ScenarioListResponse;
}

export class YearDto implements IYearDto {
    year!: number;
    yearValue!: number | undefined;
    primId!: number;
    idExists!: boolean;

    constructor(data?: IYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.yearValue = _data["yearValue"];
            this.primId = _data["primId"];
            this.idExists = _data["idExists"];
        }
    }

    static fromJS(data: any): YearDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["yearValue"] = this.yearValue;
        data["primId"] = this.primId;
        data["idExists"] = this.idExists;
        return data;
    }
}

export interface IYearDto {
    year: number;
    yearValue: number | undefined;
    primId: number;
    idExists: boolean;
}

export class PrimaryDataKpiRowDto implements IPrimaryDataKpiRowDto {
    kpiType!: string | undefined;
    kpiId!: string | undefined;
    countryName!: string | undefined;
    plantName!: string | undefined;
    unitName!: string | undefined;
    technologyName!: string | undefined;
    machineSid!: number;
    kpiDesc!: string | undefined;
    isAllMissing!: boolean;
    years!: YearDto[] | undefined;

    constructor(data?: IPrimaryDataKpiRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiType = _data["kpiType"];
            this.kpiId = _data["kpiId"];
            this.countryName = _data["countryName"];
            this.plantName = _data["plantName"];
            this.unitName = _data["unitName"];
            this.technologyName = _data["technologyName"];
            this.machineSid = _data["machineSid"];
            this.kpiDesc = _data["kpiDesc"];
            this.isAllMissing = _data["isAllMissing"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(YearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): PrimaryDataKpiRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryDataKpiRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiType"] = this.kpiType;
        data["kpiId"] = this.kpiId;
        data["countryName"] = this.countryName;
        data["plantName"] = this.plantName;
        data["unitName"] = this.unitName;
        data["technologyName"] = this.technologyName;
        data["machineSid"] = this.machineSid;
        data["kpiDesc"] = this.kpiDesc;
        data["isAllMissing"] = this.isAllMissing;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        return data;
    }
}

export interface IPrimaryDataKpiRowDto {
    kpiType: string | undefined;
    kpiId: string | undefined;
    countryName: string | undefined;
    plantName: string | undefined;
    unitName: string | undefined;
    technologyName: string | undefined;
    machineSid: number;
    kpiDesc: string | undefined;
    isAllMissing: boolean;
    years: YearDto[] | undefined;
}

/** Primary Data List Response. */
export class PrimaryDataListResponse implements IPrimaryDataListResponse {
    total!: number;
    items!: PrimaryDataKpiRowDto[] | undefined;
    isEtlPipelineFinished!: boolean;

    constructor(data?: IPrimaryDataListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(PrimaryDataKpiRowDto.fromJS(item));
            }
            this.isEtlPipelineFinished = _data["isEtlPipelineFinished"];
        }
    }

    static fromJS(data: any): PrimaryDataListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryDataListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        data["isEtlPipelineFinished"] = this.isEtlPipelineFinished;
        return data;
    }
}

/** Primary Data List Response. */
export interface IPrimaryDataListResponse {
    total: number;
    items: PrimaryDataKpiRowDto[] | undefined;
    isEtlPipelineFinished: boolean;
}

export class PrimaryDataListResponseOkResponse implements IPrimaryDataListResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: PrimaryDataListResponse;

    constructor(data?: IPrimaryDataListResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? PrimaryDataListResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrimaryDataListResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryDataListResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrimaryDataListResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: PrimaryDataListResponse;
}

export class MaintenanceCycleValuesViewDto implements IMaintenanceCycleValuesViewDto {
    technology!: string | undefined;
    country!: string | undefined;
    plant!: string | undefined;
    unit!: string | undefined;
    machineSid!: number;
    numberOfSelectedYears!: number;
    years!: MaintenanceYearDto[] | undefined;

    constructor(data?: IMaintenanceCycleValuesViewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.technology = _data["technology"];
            this.country = _data["country"];
            this.plant = _data["plant"];
            this.unit = _data["unit"];
            this.machineSid = _data["machineSid"];
            this.numberOfSelectedYears = _data["numberOfSelectedYears"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(MaintenanceYearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MaintenanceCycleValuesViewDto {
        data = typeof data === 'object' ? data : {};
        let result = new MaintenanceCycleValuesViewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["technology"] = this.technology;
        data["country"] = this.country;
        data["plant"] = this.plant;
        data["unit"] = this.unit;
        data["machineSid"] = this.machineSid;
        data["numberOfSelectedYears"] = this.numberOfSelectedYears;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMaintenanceCycleValuesViewDto {
    technology: string | undefined;
    country: string | undefined;
    plant: string | undefined;
    unit: string | undefined;
    machineSid: number;
    numberOfSelectedYears: number;
    years: MaintenanceYearDto[] | undefined;
}

export class ListMaintenanceCycleValuesResponse implements IListMaintenanceCycleValuesResponse {
    maintenanceCycleValues!: MaintenanceCycleValuesViewDto[] | undefined;
    total!: number;

    constructor(data?: IListMaintenanceCycleValuesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["maintenanceCycleValues"])) {
                this.maintenanceCycleValues = [] as any;
                for (let item of _data["maintenanceCycleValues"])
                    this.maintenanceCycleValues!.push(MaintenanceCycleValuesViewDto.fromJS(item));
            }
            this.total = _data["total"];
        }
    }

    static fromJS(data: any): ListMaintenanceCycleValuesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMaintenanceCycleValuesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.maintenanceCycleValues)) {
            data["maintenanceCycleValues"] = [];
            for (let item of this.maintenanceCycleValues)
                data["maintenanceCycleValues"].push(item.toJSON());
        }
        data["total"] = this.total;
        return data;
    }
}

export interface IListMaintenanceCycleValuesResponse {
    maintenanceCycleValues: MaintenanceCycleValuesViewDto[] | undefined;
    total: number;
}

export class ListMaintenanceCycleValuesResponseOkResponse implements IListMaintenanceCycleValuesResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ListMaintenanceCycleValuesResponse;

    constructor(data?: IListMaintenanceCycleValuesResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ListMaintenanceCycleValuesResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListMaintenanceCycleValuesResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListMaintenanceCycleValuesResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListMaintenanceCycleValuesResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ListMaintenanceCycleValuesResponse;
}

/** 1 = KPI_TYPE 2 = KPI_ID 3 = KPI_DESC */
export enum SortableKpiField {
    KPI_TYPE = 1,
    KPI_ID = 2,
    KPI_DESC = 3,
}

export class KpiUsedByDto implements IKpiUsedByDto {
    kpiNumber!: number;
    kpisDependent!: string[] | undefined;

    constructor(data?: IKpiUsedByDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiNumber = _data["kpiNumber"];
            if (Array.isArray(_data["kpisDependent"])) {
                this.kpisDependent = [] as any;
                for (let item of _data["kpisDependent"])
                    this.kpisDependent!.push(item);
            }
        }
    }

    static fromJS(data: any): KpiUsedByDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiUsedByDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiNumber"] = this.kpiNumber;
        if (Array.isArray(this.kpisDependent)) {
            data["kpisDependent"] = [];
            for (let item of this.kpisDependent)
                data["kpisDependent"].push(item);
        }
        return data;
    }
}

export interface IKpiUsedByDto {
    kpiNumber: number;
    kpisDependent: string[] | undefined;
}

export class KpiResponseDto implements IKpiResponseDto {
    kpiFormula!: KpiDto;
    kpis!: InsertFormulaKpiDto[] | undefined;
    kpiUsedBy!: KpiUsedByDto;
    runByEngine!: boolean;

    constructor(data?: IKpiResponseDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiFormula = _data["kpiFormula"] ? KpiDto.fromJS(_data["kpiFormula"]) : <any>undefined;
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(InsertFormulaKpiDto.fromJS(item));
            }
            this.kpiUsedBy = _data["kpiUsedBy"] ? KpiUsedByDto.fromJS(_data["kpiUsedBy"]) : <any>undefined;
            this.runByEngine = _data["runByEngine"];
        }
    }

    static fromJS(data: any): KpiResponseDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiResponseDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiFormula"] = this.kpiFormula ? this.kpiFormula.toJSON() : <any>undefined;
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        data["kpiUsedBy"] = this.kpiUsedBy ? this.kpiUsedBy.toJSON() : <any>undefined;
        data["runByEngine"] = this.runByEngine;
        return data;
    }
}

export interface IKpiResponseDto {
    kpiFormula: KpiDto;
    kpis: InsertFormulaKpiDto[] | undefined;
    kpiUsedBy: KpiUsedByDto;
    runByEngine: boolean;
}

export class KpiListResponse implements IKpiListResponse {
    count!: number;
    items!: KpiResponseDto[] | undefined;

    constructor(data?: IKpiListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(KpiResponseDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): KpiListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KpiListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IKpiListResponse {
    count: number;
    items: KpiResponseDto[] | undefined;
}

export class KpiListResponseOkResponse implements IKpiListResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: KpiListResponse;

    constructor(data?: IKpiListResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? KpiListResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): KpiListResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new KpiListResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IKpiListResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: KpiListResponse;
}

export class CountryInflationDto implements ICountryInflationDto {
    countryName!: string | undefined;
    inflations!: InflationDto[] | undefined;

    constructor(data?: ICountryInflationDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.countryName = _data["countryName"];
            if (Array.isArray(_data["inflations"])) {
                this.inflations = [] as any;
                for (let item of _data["inflations"])
                    this.inflations!.push(InflationDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CountryInflationDto {
        data = typeof data === 'object' ? data : {};
        let result = new CountryInflationDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["countryName"] = this.countryName;
        if (Array.isArray(this.inflations)) {
            data["inflations"] = [];
            for (let item of this.inflations)
                data["inflations"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICountryInflationDto {
    countryName: string | undefined;
    inflations: InflationDto[] | undefined;
}

export class InflationListResponse implements IInflationListResponse {
    countryInflations!: CountryInflationDto[] | undefined;
    count!: number;
    startYear!: number;
    endYear!: number;
    referenceYear!: number;

    constructor(data?: IInflationListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["countryInflations"])) {
                this.countryInflations = [] as any;
                for (let item of _data["countryInflations"])
                    this.countryInflations!.push(CountryInflationDto.fromJS(item));
            }
            this.count = _data["count"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.referenceYear = _data["referenceYear"];
        }
    }

    static fromJS(data: any): InflationListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InflationListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.countryInflations)) {
            data["countryInflations"] = [];
            for (let item of this.countryInflations)
                data["countryInflations"].push(item.toJSON());
        }
        data["count"] = this.count;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["referenceYear"] = this.referenceYear;
        return data;
    }
}

export interface IInflationListResponse {
    countryInflations: CountryInflationDto[] | undefined;
    count: number;
    startYear: number;
    endYear: number;
    referenceYear: number;
}

export class InflationListResponseOkResponse implements IInflationListResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: InflationListResponse;

    constructor(data?: IInflationListResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? InflationListResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): InflationListResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new InflationListResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IInflationListResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: InflationListResponse;
}

export class SidWithNameFilterDto implements ISidWithNameFilterDto {
    sid!: number;
    name!: string | undefined;

    constructor(data?: ISidWithNameFilterDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.sid = _data["sid"];
            this.name = _data["name"];
        }
    }

    static fromJS(data: any): SidWithNameFilterDto {
        data = typeof data === 'object' ? data : {};
        let result = new SidWithNameFilterDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["sid"] = this.sid;
        data["name"] = this.name;
        return data;
    }
}

export interface ISidWithNameFilterDto {
    sid: number;
    name: string | undefined;
}

export class YearRangeDto implements IYearRangeDto {
    startYear!: number;
    endYear!: number;

    constructor(data?: IYearRangeDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
        }
    }

    static fromJS(data: any): YearRangeDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearRangeDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        return data;
    }
}

export interface IYearRangeDto {
    startYear: number;
    endYear: number;
}

export class FilterResponse implements IFilterResponse {
    mtcKpiIds!: string[] | undefined;
    plants!: SidWithNameFilterDto[] | undefined;
    countries!: SidWithNameFilterDto[] | undefined;
    technologies!: SidWithNameFilterDto[] | undefined;
    planningControllingClassification!: { [key: string]: string; } | undefined;
    projectTypes!: { [key: string]: string; } | undefined;
    aeroClassification!: { [key: string]: string; } | undefined;
    years!: YearRangeDto;
    kpiTypes!: { [key: string]: string; } | undefined;
    units!: SidWithNameFilterDto[] | undefined;

    constructor(data?: IFilterResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["mtcKpiIds"])) {
                this.mtcKpiIds = [] as any;
                for (let item of _data["mtcKpiIds"])
                    this.mtcKpiIds!.push(item);
            }
            if (Array.isArray(_data["plants"])) {
                this.plants = [] as any;
                for (let item of _data["plants"])
                    this.plants!.push(SidWithNameFilterDto.fromJS(item));
            }
            if (Array.isArray(_data["countries"])) {
                this.countries = [] as any;
                for (let item of _data["countries"])
                    this.countries!.push(SidWithNameFilterDto.fromJS(item));
            }
            if (Array.isArray(_data["technologies"])) {
                this.technologies = [] as any;
                for (let item of _data["technologies"])
                    this.technologies!.push(SidWithNameFilterDto.fromJS(item));
            }
            if (_data["planningControllingClassification"]) {
                this.planningControllingClassification = {} as any;
                for (let key in _data["planningControllingClassification"]) {
                    if (_data["planningControllingClassification"].hasOwnProperty(key))
                        this.planningControllingClassification![key] = _data["planningControllingClassification"][key];
                }
            }
            if (_data["projectTypes"]) {
                this.projectTypes = {} as any;
                for (let key in _data["projectTypes"]) {
                    if (_data["projectTypes"].hasOwnProperty(key))
                        this.projectTypes![key] = _data["projectTypes"][key];
                }
            }
            if (_data["aeroClassification"]) {
                this.aeroClassification = {} as any;
                for (let key in _data["aeroClassification"]) {
                    if (_data["aeroClassification"].hasOwnProperty(key))
                        this.aeroClassification![key] = _data["aeroClassification"][key];
                }
            }
            this.years = _data["years"] ? YearRangeDto.fromJS(_data["years"]) : <any>undefined;
            if (_data["kpiTypes"]) {
                this.kpiTypes = {} as any;
                for (let key in _data["kpiTypes"]) {
                    if (_data["kpiTypes"].hasOwnProperty(key))
                        this.kpiTypes![key] = _data["kpiTypes"][key];
                }
            }
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(SidWithNameFilterDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): FilterResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.mtcKpiIds)) {
            data["mtcKpiIds"] = [];
            for (let item of this.mtcKpiIds)
                data["mtcKpiIds"].push(item);
        }
        if (Array.isArray(this.plants)) {
            data["plants"] = [];
            for (let item of this.plants)
                data["plants"].push(item.toJSON());
        }
        if (Array.isArray(this.countries)) {
            data["countries"] = [];
            for (let item of this.countries)
                data["countries"].push(item.toJSON());
        }
        if (Array.isArray(this.technologies)) {
            data["technologies"] = [];
            for (let item of this.technologies)
                data["technologies"].push(item.toJSON());
        }
        if (this.planningControllingClassification) {
            data["planningControllingClassification"] = {};
            for (let key in this.planningControllingClassification) {
                if (this.planningControllingClassification.hasOwnProperty(key))
                    data["planningControllingClassification"][key] = this.planningControllingClassification[key];
            }
        }
        if (this.projectTypes) {
            data["projectTypes"] = {};
            for (let key in this.projectTypes) {
                if (this.projectTypes.hasOwnProperty(key))
                    data["projectTypes"][key] = this.projectTypes[key];
            }
        }
        if (this.aeroClassification) {
            data["aeroClassification"] = {};
            for (let key in this.aeroClassification) {
                if (this.aeroClassification.hasOwnProperty(key))
                    data["aeroClassification"][key] = this.aeroClassification[key];
            }
        }
        data["years"] = this.years ? this.years.toJSON() : <any>undefined;
        if (this.kpiTypes) {
            data["kpiTypes"] = {};
            for (let key in this.kpiTypes) {
                if (this.kpiTypes.hasOwnProperty(key))
                    data["kpiTypes"][key] = this.kpiTypes[key];
            }
        }
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IFilterResponse {
    mtcKpiIds: string[] | undefined;
    plants: SidWithNameFilterDto[] | undefined;
    countries: SidWithNameFilterDto[] | undefined;
    technologies: SidWithNameFilterDto[] | undefined;
    planningControllingClassification: { [key: string]: string; } | undefined;
    projectTypes: { [key: string]: string; } | undefined;
    aeroClassification: { [key: string]: string; } | undefined;
    years: YearRangeDto;
    kpiTypes: { [key: string]: string; } | undefined;
    units: SidWithNameFilterDto[] | undefined;
}

export class FilterResponseOkResponse implements IFilterResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: FilterResponse;

    constructor(data?: IFilterResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? FilterResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): FilterResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new FilterResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IFilterResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: FilterResponse;
}

/** 0 = NAME 1 = Started_By 2 = Created_Updated */
export enum SortableEngineRunField {
    NAME = 0,
    Started_By = 1,
    Created_Updated = 2,
}

export class ScenarioRunDto implements IScenarioRunDto {
    id!: number;
    name!: string | undefined;
    description!: string | undefined;
    kpisCalculated!: number;
    years!: number;
    status!: number;
    sites!: number;
    units!: number;
    warnings!: number;
    startYear!: number;
    endYear!: number;
    createdUpdated!: Date;
    startedBy!: string | undefined;
    startedAt!: Date | undefined;
    lastTaskName!: string | undefined;

    constructor(data?: IScenarioRunDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.description = _data["description"];
            this.kpisCalculated = _data["kpisCalculated"];
            this.years = _data["years"];
            this.status = _data["status"];
            this.sites = _data["sites"];
            this.units = _data["units"];
            this.warnings = _data["warnings"];
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.createdUpdated = _data["createdUpdated"] ? new Date(_data["createdUpdated"].toString()) : <any>undefined;
            this.startedBy = _data["startedBy"];
            this.startedAt = _data["startedAt"] ? new Date(_data["startedAt"].toString()) : <any>undefined;
            this.lastTaskName = _data["lastTaskName"];
        }
    }

    static fromJS(data: any): ScenarioRunDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioRunDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["description"] = this.description;
        data["kpisCalculated"] = this.kpisCalculated;
        data["years"] = this.years;
        data["status"] = this.status;
        data["sites"] = this.sites;
        data["units"] = this.units;
        data["warnings"] = this.warnings;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["createdUpdated"] = this.createdUpdated ? this.createdUpdated.toISOString() : <any>undefined;
        data["startedBy"] = this.startedBy;
        data["startedAt"] = this.startedAt ? this.startedAt.toISOString() : <any>undefined;
        data["lastTaskName"] = this.lastTaskName;
        return data;
    }
}

export interface IScenarioRunDto {
    id: number;
    name: string | undefined;
    description: string | undefined;
    kpisCalculated: number;
    years: number;
    status: number;
    sites: number;
    units: number;
    warnings: number;
    startYear: number;
    endYear: number;
    createdUpdated: Date;
    startedBy: string | undefined;
    startedAt: Date | undefined;
    lastTaskName: string | undefined;
}

export class EngineRunListResponse implements IEngineRunListResponse {
    count!: number;
    items!: ScenarioRunDto[] | undefined;

    constructor(data?: IEngineRunListResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ScenarioRunDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EngineRunListResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngineRunListResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEngineRunListResponse {
    count: number;
    items: ScenarioRunDto[] | undefined;
}

export class EngineRunListResponseOkResponse implements IEngineRunListResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EngineRunListResponse;

    constructor(data?: IEngineRunListResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EngineRunListResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EngineRunListResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngineRunListResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEngineRunListResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EngineRunListResponse;
}

export class CostCoefficientYearDto implements ICostCoefficientYearDto {
    id!: number;
    year!: number;
    costValue!: number | undefined;
    isValueDifferentFromPreviousYear!: boolean;

    constructor(data?: ICostCoefficientYearDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.year = _data["year"];
            this.costValue = _data["costValue"];
            this.isValueDifferentFromPreviousYear = _data["isValueDifferentFromPreviousYear"];
        }
    }

    static fromJS(data: any): CostCoefficientYearDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCoefficientYearDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["year"] = this.year;
        data["costValue"] = this.costValue;
        data["isValueDifferentFromPreviousYear"] = this.isValueDifferentFromPreviousYear;
        return data;
    }
}

export interface ICostCoefficientYearDto {
    id: number;
    year: number;
    costValue: number | undefined;
    isValueDifferentFromPreviousYear: boolean;
}

export class CostCoefficientRowDto implements ICostCoefficientRowDto {
    kpiId!: string | undefined;
    kpiDescription!: string | undefined;
    plantName!: string | undefined;
    technology!: string | undefined;
    unitName!: string | undefined;
    country!: string | undefined;
    unitSid!: number;
    years!: CostCoefficientYearDto[] | undefined;

    constructor(data?: ICostCoefficientRowDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiId = _data["kpiId"];
            this.kpiDescription = _data["kpiDescription"];
            this.plantName = _data["plantName"];
            this.technology = _data["technology"];
            this.unitName = _data["unitName"];
            this.country = _data["country"];
            this.unitSid = _data["unitSid"];
            if (Array.isArray(_data["years"])) {
                this.years = [] as any;
                for (let item of _data["years"])
                    this.years!.push(CostCoefficientYearDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): CostCoefficientRowDto {
        data = typeof data === 'object' ? data : {};
        let result = new CostCoefficientRowDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiId"] = this.kpiId;
        data["kpiDescription"] = this.kpiDescription;
        data["plantName"] = this.plantName;
        data["technology"] = this.technology;
        data["unitName"] = this.unitName;
        data["country"] = this.country;
        data["unitSid"] = this.unitSid;
        if (Array.isArray(this.years)) {
            data["years"] = [];
            for (let item of this.years)
                data["years"].push(item.toJSON());
        }
        return data;
    }
}

export interface ICostCoefficientRowDto {
    kpiId: string | undefined;
    kpiDescription: string | undefined;
    plantName: string | undefined;
    technology: string | undefined;
    unitName: string | undefined;
    country: string | undefined;
    unitSid: number;
    years: CostCoefficientYearDto[] | undefined;
}

export class ListCostCoefficientsResponse implements IListCostCoefficientsResponse {
    total!: number;
    items!: CostCoefficientRowDto[] | undefined;

    constructor(data?: IListCostCoefficientsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(CostCoefficientRowDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListCostCoefficientsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCostCoefficientsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListCostCoefficientsResponse {
    total: number;
    items: CostCoefficientRowDto[] | undefined;
}

export class ListCostCoefficientsResponseOkResponse implements IListCostCoefficientsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ListCostCoefficientsResponse;

    constructor(data?: IListCostCoefficientsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ListCostCoefficientsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListCostCoefficientsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListCostCoefficientsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListCostCoefficientsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ListCostCoefficientsResponse;
}

export class EtlLogMessage implements IEtlLogMessage {
    id!: number;
    kpiId!: string | undefined;
    logLevel!: number;
    logMethod!: string | undefined;
    logMessage!: string | undefined;
    subsection!: string | undefined;

    constructor(data?: IEtlLogMessage) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.kpiId = _data["kpiId"];
            this.logLevel = _data["logLevel"];
            this.logMethod = _data["logMethod"];
            this.logMessage = _data["logMessage"];
            this.subsection = _data["subsection"];
        }
    }

    static fromJS(data: any): EtlLogMessage {
        data = typeof data === 'object' ? data : {};
        let result = new EtlLogMessage();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["kpiId"] = this.kpiId;
        data["logLevel"] = this.logLevel;
        data["logMethod"] = this.logMethod;
        data["logMessage"] = this.logMessage;
        data["subsection"] = this.subsection;
        return data;
    }
}

export interface IEtlLogMessage {
    id: number;
    kpiId: string | undefined;
    logLevel: number;
    logMethod: string | undefined;
    logMessage: string | undefined;
    subsection: string | undefined;
}

export class ListEtlLogsResponse implements IListEtlLogsResponse {
    total!: number;
    items!: EtlLogMessage[] | undefined;

    constructor(data?: IListEtlLogsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EtlLogMessage.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListEtlLogsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListEtlLogsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListEtlLogsResponse {
    total: number;
    items: EtlLogMessage[] | undefined;
}

export class ListEtlLogsResponseOkResponse implements IListEtlLogsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ListEtlLogsResponse;

    constructor(data?: IListEtlLogsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ListEtlLogsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListEtlLogsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListEtlLogsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListEtlLogsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ListEtlLogsResponse;
}

export class ReportingOccasionDto implements IReportingOccasionDto {
    reportingOccasion!: string | undefined;
    asOfDate!: Date;

    constructor(data?: IReportingOccasionDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.reportingOccasion = _data["reportingOccasion"];
            this.asOfDate = _data["asOfDate"] ? new Date(_data["asOfDate"].toString()) : <any>undefined;
        }
    }

    static fromJS(data: any): ReportingOccasionDto {
        data = typeof data === 'object' ? data : {};
        let result = new ReportingOccasionDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["reportingOccasion"] = this.reportingOccasion;
        data["asOfDate"] = this.asOfDate ? this.asOfDate.toISOString() : <any>undefined;
        return data;
    }
}

export interface IReportingOccasionDto {
    reportingOccasion: string | undefined;
    asOfDate: Date;
}

export class ListReportingOccasionResponse implements IListReportingOccasionResponse {
    reportingOccasions!: ReportingOccasionDto[] | undefined;

    constructor(data?: IListReportingOccasionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["reportingOccasions"])) {
                this.reportingOccasions = [] as any;
                for (let item of _data["reportingOccasions"])
                    this.reportingOccasions!.push(ReportingOccasionDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ListReportingOccasionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListReportingOccasionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.reportingOccasions)) {
            data["reportingOccasions"] = [];
            for (let item of this.reportingOccasions)
                data["reportingOccasions"].push(item.toJSON());
        }
        return data;
    }
}

export interface IListReportingOccasionResponse {
    reportingOccasions: ReportingOccasionDto[] | undefined;
}

export class ListReportingOccasionResponseOkResponse implements IListReportingOccasionResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ListReportingOccasionResponse;

    constructor(data?: IListReportingOccasionResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ListReportingOccasionResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ListReportingOccasionResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ListReportingOccasionResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IListReportingOccasionResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ListReportingOccasionResponse;
}

export class MarkDto implements IMarkDto {
    scenarioId!: number;
    isMarked!: boolean;

    constructor(data?: IMarkDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.scenarioId = _data["scenarioId"];
            this.isMarked = _data["isMarked"];
        }
    }

    static fromJS(data: any): MarkDto {
        data = typeof data === 'object' ? data : {};
        let result = new MarkDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["scenarioId"] = this.scenarioId;
        data["isMarked"] = this.isMarked;
        return data;
    }
}

export interface IMarkDto {
    scenarioId: number;
    isMarked: boolean;
}

export class MarkRequest implements IMarkRequest {
    scenarios!: MarkDto[] | undefined;

    constructor(data?: IMarkRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["scenarios"])) {
                this.scenarios = [] as any;
                for (let item of _data["scenarios"])
                    this.scenarios!.push(MarkDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MarkRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.scenarios)) {
            data["scenarios"] = [];
            for (let item of this.scenarios)
                data["scenarios"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMarkRequest {
    scenarios: MarkDto[] | undefined;
}

export class MarkResponse implements IMarkResponse {
    updatedScenarios!: number;

    constructor(data?: IMarkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.updatedScenarios = _data["updatedScenarios"];
        }
    }

    static fromJS(data: any): MarkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["updatedScenarios"] = this.updatedScenarios;
        return data;
    }
}

export interface IMarkResponse {
    updatedScenarios: number;
}

export class MarkResponseOkResponse implements IMarkResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: MarkResponse;

    constructor(data?: IMarkResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? MarkResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarkResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMarkResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: MarkResponse;
}

export class MarkErrorRequest implements IMarkErrorRequest {
    errors!: number[] | undefined;

    constructor(data?: IMarkErrorRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["errors"])) {
                this.errors = [] as any;
                for (let item of _data["errors"])
                    this.errors!.push(item);
            }
        }
    }

    static fromJS(data: any): MarkErrorRequest {
        data = typeof data === 'object' ? data : {};
        let result = new MarkErrorRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.errors)) {
            data["errors"] = [];
            for (let item of this.errors)
                data["errors"].push(item);
        }
        return data;
    }
}

export interface IMarkErrorRequest {
    errors: number[] | undefined;
}

export class MarkErrorResponse implements IMarkErrorResponse {
    markedErrors!: number;

    constructor(data?: IMarkErrorResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.markedErrors = _data["markedErrors"];
        }
    }

    static fromJS(data: any): MarkErrorResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkErrorResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["markedErrors"] = this.markedErrors;
        return data;
    }
}

export interface IMarkErrorResponse {
    markedErrors: number;
}

export class MarkErrorResponseOkResponse implements IMarkErrorResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: MarkErrorResponse;

    constructor(data?: IMarkErrorResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? MarkErrorResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MarkErrorResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MarkErrorResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMarkErrorResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: MarkErrorResponse;
}

export class StreamUnitAttributeListDto implements IStreamUnitAttributeListDto {
    id!: number;
    name!: string | undefined;
    abbreviation!: string | undefined;
    description!: string | undefined;
    typeId!: number | undefined;
    powerPlantId!: number | undefined;
    powerPlantName!: string | undefined;
    fleetId!: number | undefined;
    fleetName!: string | undefined;
    countryId!: number | undefined;
    countryName!: string | undefined;
    objectTypeId!: number | undefined;
    sapTypeId!: number | undefined;

    constructor(data?: IStreamUnitAttributeListDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.name = _data["name"];
            this.abbreviation = _data["abbreviation"];
            this.description = _data["description"];
            this.typeId = _data["typeId"];
            this.powerPlantId = _data["powerPlantId"];
            this.powerPlantName = _data["powerPlantName"];
            this.fleetId = _data["fleetId"];
            this.fleetName = _data["fleetName"];
            this.countryId = _data["countryId"];
            this.countryName = _data["countryName"];
            this.objectTypeId = _data["objectTypeId"];
            this.sapTypeId = _data["sapTypeId"];
        }
    }

    static fromJS(data: any): StreamUnitAttributeListDto {
        data = typeof data === 'object' ? data : {};
        let result = new StreamUnitAttributeListDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["name"] = this.name;
        data["abbreviation"] = this.abbreviation;
        data["description"] = this.description;
        data["typeId"] = this.typeId;
        data["powerPlantId"] = this.powerPlantId;
        data["powerPlantName"] = this.powerPlantName;
        data["fleetId"] = this.fleetId;
        data["fleetName"] = this.fleetName;
        data["countryId"] = this.countryId;
        data["countryName"] = this.countryName;
        data["objectTypeId"] = this.objectTypeId;
        data["sapTypeId"] = this.sapTypeId;
        return data;
    }
}

export interface IStreamUnitAttributeListDto {
    id: number;
    name: string | undefined;
    abbreviation: string | undefined;
    description: string | undefined;
    typeId: number | undefined;
    powerPlantId: number | undefined;
    powerPlantName: string | undefined;
    fleetId: number | undefined;
    fleetName: string | undefined;
    countryId: number | undefined;
    countryName: string | undefined;
    objectTypeId: number | undefined;
    sapTypeId: number | undefined;
}

export class MasterDataGetAttributesResponse implements IMasterDataGetAttributesResponse {
    list!: StreamUnitAttributeListDto[] | undefined;

    constructor(data?: IMasterDataGetAttributesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["list"])) {
                this.list = [] as any;
                for (let item of _data["list"])
                    this.list!.push(StreamUnitAttributeListDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): MasterDataGetAttributesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGetAttributesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.list)) {
            data["list"] = [];
            for (let item of this.list)
                data["list"].push(item.toJSON());
        }
        return data;
    }
}

export interface IMasterDataGetAttributesResponse {
    list: StreamUnitAttributeListDto[] | undefined;
}

export class MasterDataGetAttributesResponseOkResponse implements IMasterDataGetAttributesResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: MasterDataGetAttributesResponse;

    constructor(data?: IMasterDataGetAttributesResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? MasterDataGetAttributesResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): MasterDataGetAttributesResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new MasterDataGetAttributesResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IMasterDataGetAttributesResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: MasterDataGetAttributesResponse;
}

export class PingGetResponse implements IPingGetResponse {
    timestamp!: number;

    constructor(data?: IPingGetResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.timestamp = _data["timestamp"];
        }
    }

    static fromJS(data: any): PingGetResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PingGetResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["timestamp"] = this.timestamp;
        return data;
    }
}

export interface IPingGetResponse {
    timestamp: number;
}

export class PingGetResponseOkResponse implements IPingGetResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: PingGetResponse;

    constructor(data?: IPingGetResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? PingGetResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PingGetResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PingGetResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPingGetResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: PingGetResponse;
}

/** 0 = Singleton 1 = Scoped 2 = Transient */
export enum ServiceLifetime {
    Singleton = 0,
    Scoped = 1,
    Transient = 2,
}

export class ServiceDto implements IServiceDto {
    serviceType!: string | undefined;
    implementationType!: string | undefined;
    lifetime!: ServiceLifetime;

    constructor(data?: IServiceDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.serviceType = _data["serviceType"];
            this.implementationType = _data["implementationType"];
            this.lifetime = _data["lifetime"];
        }
    }

    static fromJS(data: any): ServiceDto {
        data = typeof data === 'object' ? data : {};
        let result = new ServiceDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["serviceType"] = this.serviceType;
        data["implementationType"] = this.implementationType;
        data["lifetime"] = this.lifetime;
        return data;
    }
}

export interface IServiceDto {
    serviceType: string | undefined;
    implementationType: string | undefined;
    lifetime: ServiceLifetime;
}

export class RegisteredServicesResponse implements IRegisteredServicesResponse {
    items!: ServiceDto[] | undefined;

    constructor(data?: IRegisteredServicesResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(ServiceDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): RegisteredServicesResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredServicesResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IRegisteredServicesResponse {
    items: ServiceDto[] | undefined;
}

export class RegisteredServicesResponseOkResponse implements IRegisteredServicesResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: RegisteredServicesResponse;

    constructor(data?: IRegisteredServicesResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? RegisteredServicesResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): RegisteredServicesResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new RegisteredServicesResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IRegisteredServicesResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: RegisteredServicesResponse;
}

export class ScenarioYearResultValue implements IScenarioYearResultValue {
    value!: number | undefined;
    isCalculated!: boolean;

    constructor(data?: IScenarioYearResultValue) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.value = _data["value"];
            this.isCalculated = _data["isCalculated"];
        }
    }

    static fromJS(data: any): ScenarioYearResultValue {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioYearResultValue();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["value"] = this.value;
        data["isCalculated"] = this.isCalculated;
        return data;
    }
}

export interface IScenarioYearResultValue {
    value: number | undefined;
    isCalculated: boolean;
}

export class YearComparisonDto implements IYearComparisonDto {
    year!: number;
    status!: number;
    firstKpiData!: ScenarioYearResultValue;
    secondKpiData!: ScenarioYearResultValue;
    percentageChange!: number | undefined;

    constructor(data?: IYearComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.year = _data["year"];
            this.status = _data["status"];
            this.firstKpiData = _data["firstKpiData"] ? ScenarioYearResultValue.fromJS(_data["firstKpiData"]) : <any>undefined;
            this.secondKpiData = _data["secondKpiData"] ? ScenarioYearResultValue.fromJS(_data["secondKpiData"]) : <any>undefined;
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): YearComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new YearComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["year"] = this.year;
        data["status"] = this.status;
        data["firstKpiData"] = this.firstKpiData ? this.firstKpiData.toJSON() : <any>undefined;
        data["secondKpiData"] = this.secondKpiData ? this.secondKpiData.toJSON() : <any>undefined;
        data["percentageChange"] = this.percentageChange;
        return data;
    }
}

export interface IYearComparisonDto {
    year: number;
    status: number;
    firstKpiData: ScenarioYearResultValue;
    secondKpiData: ScenarioYearResultValue;
    percentageChange: number | undefined;
}

export class ScenarioCompareDetailsResponse implements IScenarioCompareDetailsResponse {
    items!: YearComparisonDto[] | undefined;

    constructor(data?: IScenarioCompareDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(YearComparisonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioCompareDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCompareDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioCompareDetailsResponse {
    items: YearComparisonDto[] | undefined;
}

export class ScenarioCompareDetailsResponseOkResponse implements IScenarioCompareDetailsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ScenarioCompareDetailsResponse;

    constructor(data?: IScenarioCompareDetailsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ScenarioCompareDetailsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScenarioCompareDetailsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCompareDetailsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScenarioCompareDetailsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ScenarioCompareDetailsResponse;
}

export class ScenarioCompareOverviewDto implements IScenarioCompareOverviewDto {
    numberOfGreenCells!: number;
    numberOfRedCells!: number;
    numberOfOrangeCells!: number;
    numberOfGreyCells!: number;

    constructor(data?: IScenarioCompareOverviewDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.numberOfGreenCells = _data["numberOfGreenCells"];
            this.numberOfRedCells = _data["numberOfRedCells"];
            this.numberOfOrangeCells = _data["numberOfOrangeCells"];
            this.numberOfGreyCells = _data["numberOfGreyCells"];
        }
    }

    static fromJS(data: any): ScenarioCompareOverviewDto {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCompareOverviewDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["numberOfGreenCells"] = this.numberOfGreenCells;
        data["numberOfRedCells"] = this.numberOfRedCells;
        data["numberOfOrangeCells"] = this.numberOfOrangeCells;
        data["numberOfGreyCells"] = this.numberOfGreyCells;
        return data;
    }
}

export interface IScenarioCompareOverviewDto {
    numberOfGreenCells: number;
    numberOfRedCells: number;
    numberOfOrangeCells: number;
    numberOfGreyCells: number;
}

export class KpiColumnDto implements IKpiColumnDto {
    kpiId!: string | undefined;
    kpiDescription!: string | undefined;

    constructor(data?: IKpiColumnDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiId = _data["kpiId"];
            this.kpiDescription = _data["kpiDescription"];
        }
    }

    static fromJS(data: any): KpiColumnDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiColumnDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiId"] = this.kpiId;
        data["kpiDescription"] = this.kpiDescription;
        return data;
    }
}

export interface IKpiColumnDto {
    kpiId: string | undefined;
    kpiDescription: string | undefined;
}

export class KpiDataComparisonDto implements IKpiDataComparisonDto {
    status!: number;
    percentageChange!: number | undefined;

    constructor(data?: IKpiDataComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.status = _data["status"];
            this.percentageChange = _data["percentageChange"];
        }
    }

    static fromJS(data: any): KpiDataComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new KpiDataComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["status"] = this.status;
        data["percentageChange"] = this.percentageChange;
        return data;
    }
}

export interface IKpiDataComparisonDto {
    status: number;
    percentageChange: number | undefined;
}

export class UnitDataComparisonDto implements IUnitDataComparisonDto {
    machineSid!: number;
    unitName!: string | undefined;
    kpiDataDictionary!: { [key: string]: KpiDataComparisonDto; } | undefined;

    constructor(data?: IUnitDataComparisonDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.machineSid = _data["machineSid"];
            this.unitName = _data["unitName"];
            if (_data["kpiDataDictionary"]) {
                this.kpiDataDictionary = {} as any;
                for (let key in _data["kpiDataDictionary"]) {
                    if (_data["kpiDataDictionary"].hasOwnProperty(key))
                        this.kpiDataDictionary![key] = _data["kpiDataDictionary"][key] ? KpiDataComparisonDto.fromJS(_data["kpiDataDictionary"][key]) : new KpiDataComparisonDto();
                }
            }
        }
    }

    static fromJS(data: any): UnitDataComparisonDto {
        data = typeof data === 'object' ? data : {};
        let result = new UnitDataComparisonDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["machineSid"] = this.machineSid;
        data["unitName"] = this.unitName;
        if (this.kpiDataDictionary) {
            data["kpiDataDictionary"] = {};
            for (let key in this.kpiDataDictionary) {
                if (this.kpiDataDictionary.hasOwnProperty(key))
                    data["kpiDataDictionary"][key] = this.kpiDataDictionary[key] ? this.kpiDataDictionary[key].toJSON() : <any>undefined;
            }
        }
        return data;
    }
}

export interface IUnitDataComparisonDto {
    machineSid: number;
    unitName: string | undefined;
    kpiDataDictionary: { [key: string]: KpiDataComparisonDto; } | undefined;
}

export class ScenarioCompareResponse implements IScenarioCompareResponse {
    overview!: ScenarioCompareOverviewDto;
    kpis!: KpiColumnDto[] | undefined;
    data!: UnitDataComparisonDto[] | undefined;

    constructor(data?: IScenarioCompareResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.overview = _data["overview"] ? ScenarioCompareOverviewDto.fromJS(_data["overview"]) : <any>undefined;
            if (Array.isArray(_data["kpis"])) {
                this.kpis = [] as any;
                for (let item of _data["kpis"])
                    this.kpis!.push(KpiColumnDto.fromJS(item));
            }
            if (Array.isArray(_data["data"])) {
                this.data = [] as any;
                for (let item of _data["data"])
                    this.data!.push(UnitDataComparisonDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): ScenarioCompareResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCompareResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["overview"] = this.overview ? this.overview.toJSON() : <any>undefined;
        if (Array.isArray(this.kpis)) {
            data["kpis"] = [];
            for (let item of this.kpis)
                data["kpis"].push(item.toJSON());
        }
        if (Array.isArray(this.data)) {
            data["data"] = [];
            for (let item of this.data)
                data["data"].push(item.toJSON());
        }
        return data;
    }
}

export interface IScenarioCompareResponse {
    overview: ScenarioCompareOverviewDto;
    kpis: KpiColumnDto[] | undefined;
    data: UnitDataComparisonDto[] | undefined;
}

export class ScenarioCompareResponseOkResponse implements IScenarioCompareResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ScenarioCompareResponse;

    constructor(data?: IScenarioCompareResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ScenarioCompareResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ScenarioCompareResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ScenarioCompareResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IScenarioCompareResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ScenarioCompareResponse;
}

export class StartEngineRunResponse implements IStartEngineRunResponse {
    jobName!: string | undefined;
    jobId!: string | undefined;
    state!: string | undefined;

    constructor(data?: IStartEngineRunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"];
            this.jobId = _data["jobId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): StartEngineRunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartEngineRunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["jobId"] = this.jobId;
        data["state"] = this.state;
        return data;
    }
}

export interface IStartEngineRunResponse {
    jobName: string | undefined;
    jobId: string | undefined;
    state: string | undefined;
}

export class StartEngineRunResponseOkResponse implements IStartEngineRunResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: StartEngineRunResponse;

    constructor(data?: IStartEngineRunResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? StartEngineRunResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StartEngineRunResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StartEngineRunResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStartEngineRunResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: StartEngineRunResponse;
}

export class StatusDistributionRequest implements IStatusDistributionRequest {

    constructor(data?: IStatusDistributionRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StatusDistributionRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDistributionRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IStatusDistributionRequest {
}

export class StatusDistributionResponse implements IStatusDistributionResponse {
    total!: number;
    statusDistribution!: { [key: string]: number; } | undefined;

    constructor(data?: IStatusDistributionResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.total = _data["total"];
            if (_data["statusDistribution"]) {
                this.statusDistribution = {} as any;
                for (let key in _data["statusDistribution"]) {
                    if (_data["statusDistribution"].hasOwnProperty(key))
                        this.statusDistribution![key] = _data["statusDistribution"][key];
                }
            }
        }
    }

    static fromJS(data: any): StatusDistributionResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDistributionResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["total"] = this.total;
        if (this.statusDistribution) {
            data["statusDistribution"] = {};
            for (let key in this.statusDistribution) {
                if (this.statusDistribution.hasOwnProperty(key))
                    data["statusDistribution"][key] = this.statusDistribution[key];
            }
        }
        return data;
    }
}

export interface IStatusDistributionResponse {
    total: number;
    statusDistribution: { [key: string]: number; } | undefined;
}

export class StatusDistributionResponseOkResponse implements IStatusDistributionResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: StatusDistributionResponse;

    constructor(data?: IStatusDistributionResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? StatusDistributionResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StatusDistributionResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StatusDistributionResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStatusDistributionResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: StatusDistributionResponse;
}

export class StopEngineRunResponse implements IStopEngineRunResponse {
    jobName!: string | undefined;
    jobId!: string | undefined;
    state!: string | undefined;

    constructor(data?: IStopEngineRunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.jobName = _data["jobName"];
            this.jobId = _data["jobId"];
            this.state = _data["state"];
        }
    }

    static fromJS(data: any): StopEngineRunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StopEngineRunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["jobName"] = this.jobName;
        data["jobId"] = this.jobId;
        data["state"] = this.state;
        return data;
    }
}

export interface IStopEngineRunResponse {
    jobName: string | undefined;
    jobId: string | undefined;
    state: string | undefined;
}

export class StopEngineRunResponseOkResponse implements IStopEngineRunResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: StopEngineRunResponse;

    constructor(data?: IStopEngineRunResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? StopEngineRunResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StopEngineRunResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StopEngineRunResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStopEngineRunResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: StopEngineRunResponse;
}

export class StopAllEngineRunRequest implements IStopAllEngineRunRequest {

    constructor(data?: IStopAllEngineRunRequest) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
    }

    static fromJS(data: any): StopAllEngineRunRequest {
        data = typeof data === 'object' ? data : {};
        let result = new StopAllEngineRunRequest();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        return data;
    }
}

export interface IStopAllEngineRunRequest {
}

export class StopAllEngineRunResponse implements IStopAllEngineRunResponse {
    stopedScenarioCount!: number;

    constructor(data?: IStopAllEngineRunResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.stopedScenarioCount = _data["stopedScenarioCount"];
        }
    }

    static fromJS(data: any): StopAllEngineRunResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StopAllEngineRunResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["stopedScenarioCount"] = this.stopedScenarioCount;
        return data;
    }
}

export interface IStopAllEngineRunResponse {
    stopedScenarioCount: number;
}

export class StopAllEngineRunResponseOkResponse implements IStopAllEngineRunResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: StopAllEngineRunResponse;

    constructor(data?: IStopAllEngineRunResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? StopAllEngineRunResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): StopAllEngineRunResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new StopAllEngineRunResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IStopAllEngineRunResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: StopAllEngineRunResponse;
}

export class UploadedFile implements IUploadedFile {
    name!: string | undefined;
    uploadedAt!: Date;
    uploadedBy!: string | undefined;

    constructor(data?: IUploadedFile) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.name = _data["name"];
            this.uploadedAt = _data["uploadedAt"] ? new Date(_data["uploadedAt"].toString()) : <any>undefined;
            this.uploadedBy = _data["uploadedBy"];
        }
    }

    static fromJS(data: any): UploadedFile {
        data = typeof data === 'object' ? data : {};
        let result = new UploadedFile();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["name"] = this.name;
        data["uploadedAt"] = this.uploadedAt ? this.uploadedAt.toISOString() : <any>undefined;
        data["uploadedBy"] = this.uploadedBy;
        return data;
    }
}

export interface IUploadedFile {
    name: string | undefined;
    uploadedAt: Date;
    uploadedBy: string | undefined;
}

export class PrimaryDataSummaryResponse implements IPrimaryDataSummaryResponse {
    kpis!: number;
    virtualUnits!: number;
    physicalUnits!: number;
    sites!: number;
    missingKpisPercent!: number;
    uploadedFile!: UploadedFile;

    constructor(data?: IPrimaryDataSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpis = _data["kpis"];
            this.virtualUnits = _data["virtualUnits"];
            this.physicalUnits = _data["physicalUnits"];
            this.sites = _data["sites"];
            this.missingKpisPercent = _data["missingKpisPercent"];
            this.uploadedFile = _data["uploadedFile"] ? UploadedFile.fromJS(_data["uploadedFile"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrimaryDataSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryDataSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpis"] = this.kpis;
        data["virtualUnits"] = this.virtualUnits;
        data["physicalUnits"] = this.physicalUnits;
        data["sites"] = this.sites;
        data["missingKpisPercent"] = this.missingKpisPercent;
        data["uploadedFile"] = this.uploadedFile ? this.uploadedFile.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrimaryDataSummaryResponse {
    kpis: number;
    virtualUnits: number;
    physicalUnits: number;
    sites: number;
    missingKpisPercent: number;
    uploadedFile: UploadedFile;
}

export class PrimaryDataSummaryResponseOkResponse implements IPrimaryDataSummaryResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: PrimaryDataSummaryResponse;

    constructor(data?: IPrimaryDataSummaryResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? PrimaryDataSummaryResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): PrimaryDataSummaryResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new PrimaryDataSummaryResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IPrimaryDataSummaryResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: PrimaryDataSummaryResponse;
}

export class SummaryResponse implements ISummaryResponse {
    selected!: number;
    unit!: number;
    unit0!: number;
    unitPlusUnit0!: number;
    active!: number;

    constructor(data?: ISummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.selected = _data["selected"];
            this.unit = _data["unit"];
            this.unit0 = _data["unit0"];
            this.unitPlusUnit0 = _data["unitPlusUnit0"];
            this.active = _data["active"];
        }
    }

    static fromJS(data: any): SummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["selected"] = this.selected;
        data["unit"] = this.unit;
        data["unit0"] = this.unit0;
        data["unitPlusUnit0"] = this.unitPlusUnit0;
        data["active"] = this.active;
        return data;
    }
}

export interface ISummaryResponse {
    selected: number;
    unit: number;
    unit0: number;
    unitPlusUnit0: number;
    active: number;
}

export class SummaryResponseOkResponse implements ISummaryResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: SummaryResponse;

    constructor(data?: ISummaryResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? SummaryResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): SummaryResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new SummaryResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface ISummaryResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: SummaryResponse;
}

export class EngineRunSummaryResponse implements IEngineRunSummaryResponse {
    units!: number;
    sites!: number;
    kpisCalculated!: number;
    createdUpdated!: Date | undefined;
    startYear!: number;
    endYear!: number;
    createdBy!: string | undefined;
    total!: number;
    warnings!: number;
    errors!: number;
    infos!: number;
    debugs!: number;
    acceptable!: number;

    constructor(data?: IEngineRunSummaryResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.units = _data["units"];
            this.sites = _data["sites"];
            this.kpisCalculated = _data["kpisCalculated"];
            this.createdUpdated = _data["createdUpdated"] ? new Date(_data["createdUpdated"].toString()) : <any>undefined;
            this.startYear = _data["startYear"];
            this.endYear = _data["endYear"];
            this.createdBy = _data["createdBy"];
            this.total = _data["total"];
            this.warnings = _data["warnings"];
            this.errors = _data["errors"];
            this.infos = _data["infos"];
            this.debugs = _data["debugs"];
            this.acceptable = _data["acceptable"];
        }
    }

    static fromJS(data: any): EngineRunSummaryResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngineRunSummaryResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["units"] = this.units;
        data["sites"] = this.sites;
        data["kpisCalculated"] = this.kpisCalculated;
        data["createdUpdated"] = this.createdUpdated ? this.createdUpdated.toISOString() : <any>undefined;
        data["startYear"] = this.startYear;
        data["endYear"] = this.endYear;
        data["createdBy"] = this.createdBy;
        data["total"] = this.total;
        data["warnings"] = this.warnings;
        data["errors"] = this.errors;
        data["infos"] = this.infos;
        data["debugs"] = this.debugs;
        data["acceptable"] = this.acceptable;
        return data;
    }
}

export interface IEngineRunSummaryResponse {
    units: number;
    sites: number;
    kpisCalculated: number;
    createdUpdated: Date | undefined;
    startYear: number;
    endYear: number;
    createdBy: string | undefined;
    total: number;
    warnings: number;
    errors: number;
    infos: number;
    debugs: number;
    acceptable: number;
}

export class EngineRunSummaryResponseOkResponse implements IEngineRunSummaryResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EngineRunSummaryResponse;

    constructor(data?: IEngineRunSummaryResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EngineRunSummaryResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EngineRunSummaryResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngineRunSummaryResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEngineRunSummaryResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EngineRunSummaryResponse;
}

export class UploadPrimaryDataResponse implements IUploadPrimaryDataResponse {
    primaryKpisEdited!: number;

    constructor(data?: IUploadPrimaryDataResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.primaryKpisEdited = _data["primaryKpisEdited"];
        }
    }

    static fromJS(data: any): UploadPrimaryDataResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPrimaryDataResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["primaryKpisEdited"] = this.primaryKpisEdited;
        return data;
    }
}

export interface IUploadPrimaryDataResponse {
    primaryKpisEdited: number;
}

export class UploadPrimaryDataResponseOkResponse implements IUploadPrimaryDataResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: UploadPrimaryDataResponse;

    constructor(data?: IUploadPrimaryDataResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? UploadPrimaryDataResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): UploadPrimaryDataResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new UploadPrimaryDataResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IUploadPrimaryDataResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: UploadPrimaryDataResponse;
}

export class ViewResponse implements IViewResponse {
    id!: number;
    globalId!: string | undefined;
    forecast!: number;
    new1!: number;
    new2!: number;
    new3!: number;
    justification!: string | undefined;
    costModifications!: CostModificationDto[] | undefined;
    yearsFinancialValues!: { [key: string]: number; } | undefined;

    constructor(data?: IViewResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.id = _data["id"];
            this.globalId = _data["globalId"];
            this.forecast = _data["forecast"];
            this.new1 = _data["new1"];
            this.new2 = _data["new2"];
            this.new3 = _data["new3"];
            this.justification = _data["justification"];
            if (Array.isArray(_data["costModifications"])) {
                this.costModifications = [] as any;
                for (let item of _data["costModifications"])
                    this.costModifications!.push(CostModificationDto.fromJS(item));
            }
            if (_data["yearsFinancialValues"]) {
                this.yearsFinancialValues = {} as any;
                for (let key in _data["yearsFinancialValues"]) {
                    if (_data["yearsFinancialValues"].hasOwnProperty(key))
                        this.yearsFinancialValues![key] = _data["yearsFinancialValues"][key];
                }
            }
        }
    }

    static fromJS(data: any): ViewResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["id"] = this.id;
        data["globalId"] = this.globalId;
        data["forecast"] = this.forecast;
        data["new1"] = this.new1;
        data["new2"] = this.new2;
        data["new3"] = this.new3;
        data["justification"] = this.justification;
        if (Array.isArray(this.costModifications)) {
            data["costModifications"] = [];
            for (let item of this.costModifications)
                data["costModifications"].push(item.toJSON());
        }
        if (this.yearsFinancialValues) {
            data["yearsFinancialValues"] = {};
            for (let key in this.yearsFinancialValues) {
                if (this.yearsFinancialValues.hasOwnProperty(key))
                    data["yearsFinancialValues"][key] = this.yearsFinancialValues[key];
            }
        }
        return data;
    }
}

export interface IViewResponse {
    id: number;
    globalId: string | undefined;
    forecast: number;
    new1: number;
    new2: number;
    new3: number;
    justification: string | undefined;
    costModifications: CostModificationDto[] | undefined;
    yearsFinancialValues: { [key: string]: number; } | undefined;

}

export class ViewResponseOkResponse implements IViewResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: ViewResponse;

    constructor(data?: IViewResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? ViewResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): ViewResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new ViewResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IViewResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: ViewResponse;
}

export class EngineUnitDto implements IEngineUnitDto {
    unitSid!: number;
    unitName!: string | undefined;
    unitUi!: string | undefined;

    constructor(data?: IEngineUnitDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.unitSid = _data["unitSid"];
            this.unitName = _data["unitName"];
            this.unitUi = _data["unitUi"];
        }
    }

    static fromJS(data: any): EngineUnitDto {
        data = typeof data === 'object' ? data : {};
        let result = new EngineUnitDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["unitSid"] = this.unitSid;
        data["unitName"] = this.unitName;
        data["unitUi"] = this.unitUi;
        return data;
    }
}

export interface IEngineUnitDto {
    unitSid: number;
    unitName: string | undefined;
    unitUi: string | undefined;
}

export class EngineLogDto implements IEngineLogDto {
    kpiId!: string | undefined;
    kpiDescription!: string | undefined;
    id!: number;
    message!: string | undefined;
    year!: number;
    logLevel!: number;
    isAcceptable!: boolean;
    units!: EngineUnitDto[] | undefined;

    constructor(data?: IEngineLogDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.kpiId = _data["kpiId"];
            this.kpiDescription = _data["kpiDescription"];
            this.id = _data["id"];
            this.message = _data["message"];
            this.year = _data["year"];
            this.logLevel = _data["logLevel"];
            this.isAcceptable = _data["isAcceptable"];
            if (Array.isArray(_data["units"])) {
                this.units = [] as any;
                for (let item of _data["units"])
                    this.units!.push(EngineUnitDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EngineLogDto {
        data = typeof data === 'object' ? data : {};
        let result = new EngineLogDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["kpiId"] = this.kpiId;
        data["kpiDescription"] = this.kpiDescription;
        data["id"] = this.id;
        data["message"] = this.message;
        data["year"] = this.year;
        data["logLevel"] = this.logLevel;
        data["isAcceptable"] = this.isAcceptable;
        if (Array.isArray(this.units)) {
            data["units"] = [];
            for (let item of this.units)
                data["units"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEngineLogDto {
    kpiId: string | undefined;
    kpiDescription: string | undefined;
    id: number;
    message: string | undefined;
    year: number;
    logLevel: number;
    isAcceptable: boolean;
    units: EngineUnitDto[] | undefined;
}

export class EngineRunDetailsResponse implements IEngineRunDetailsResponse {
    count!: number;
    items!: EngineLogDto[] | undefined;

    constructor(data?: IEngineRunDetailsResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.count = _data["count"];
            if (Array.isArray(_data["items"])) {
                this.items = [] as any;
                for (let item of _data["items"])
                    this.items!.push(EngineLogDto.fromJS(item));
            }
        }
    }

    static fromJS(data: any): EngineRunDetailsResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngineRunDetailsResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["count"] = this.count;
        if (Array.isArray(this.items)) {
            data["items"] = [];
            for (let item of this.items)
                data["items"].push(item.toJSON());
        }
        return data;
    }
}

export interface IEngineRunDetailsResponse {
    count: number;
    items: EngineLogDto[] | undefined;
}

export class EngineRunDetailsResponseOkResponse implements IEngineRunDetailsResponseOkResponse {
    readonly statusCode!: number;
    readonly statusDescription!: string | undefined;
    readonly message!: string | undefined;
    result!: EngineRunDetailsResponse;

    constructor(data?: IEngineRunDetailsResponseOkResponse) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            (<any>this).statusCode = _data["statusCode"];
            (<any>this).statusDescription = _data["statusDescription"];
            (<any>this).message = _data["message"];
            this.result = _data["result"] ? EngineRunDetailsResponse.fromJS(_data["result"]) : <any>undefined;
        }
    }

    static fromJS(data: any): EngineRunDetailsResponseOkResponse {
        data = typeof data === 'object' ? data : {};
        let result = new EngineRunDetailsResponseOkResponse();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["statusCode"] = this.statusCode;
        data["statusDescription"] = this.statusDescription;
        data["message"] = this.message;
        data["result"] = this.result ? this.result.toJSON() : <any>undefined;
        return data;
    }
}

export interface IEngineRunDetailsResponseOkResponse {
    statusCode: number;
    statusDescription: string | undefined;
    message: string | undefined;
    result: EngineRunDetailsResponse;
}

export interface FileParameter {
    data: any;
    fileName: string;
}

export class ApiException extends Error {
    message: string;
    status: number;
    response: string;
    headers: { [key: string]: any; };
    result: any;

    constructor(message: string, status: number, response: string, headers: { [key: string]: any; }, result: any) {
        super();

        this.message = message;
        this.status = status;
        this.response = response;
        this.headers = headers;
        this.result = result;
    }

    protected isApiException = true;

    static isApiException(obj: any): obj is ApiException {
        return obj.isApiException === true;
    }
}

function throwException(message: string, status: number, response: string, headers: { [key: string]: any; }, result?: any): any {
    if (result !== null && result !== undefined)
        throw result;
    else
        throw new ApiException(message, status, response, headers, null);
}

function isAxiosError(obj: any | undefined): obj is AxiosError {
    return obj && obj.isAxiosError === true;
}

class ApiConnection {
    private attempts!: number;
    private axiosInstance: AxiosInstance;

    constructor(endpoint = '', identityRequest = false) {
        this.axiosInstance = axios.create({
            baseURL: identityRequest ? endpoint : process.env.VUE_APP_API_BASE_URL + endpoint,
        });

        this.axiosInstance.interceptors.request.use(async (config) => {
            const accessToken = await sdk.auth.getToken(APP_SCOPE) ?? '';
            config.headers.Authorization = `Bearer ${accessToken}`

            return config;
        });

        this.axiosInstance.interceptors.response.use((success) => {
            if (success.config.method !== 'options') {
                this.attempts = 0;
            }

            return success;
        }, async (error) => {
            if (error.response && error.response.status === 401) {
                await sdk.auth.login('loginRedirect');
            } else if (error.response === undefined || error.message === 'Network Error') {
                throw error;
            } else {
                return Promise.reject(error);
            }
        });
    }

    public request(config: AxiosRequestConfig): Promise<any> {
        return this.axiosInstance.request(config);
    }
}
